<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedIndex"
    ref="gc-base-layout"
    class="touch-sales-order-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Sales Order'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Sales Order'
            : 'Sales Order # ' + baseView.id
        "
        :secondaryLabel="
          baseView.mode == 'review' ? model.CustomerName : undefined
        "
        v-if="loaded"
      />
    </template>
    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="model"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div v-show="selectedIndex == 0" class="gc-header-form">
        <div class="header-form-container">
          <div class="header-form">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="getHeaderFormItems"
                :isNormal="true"
                :data-model="model"
                :deliveryAddressClicked="showDeliveryAddress"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-form'"
                ref="gc-header-form"
                :valueChangeCallBack="headerFormValueChanged"
                :checkValid="isValid"
                :validationGroup="'gc-header-form'"
                :scrollingEnabled="false"
              ></gc-form>
            </div>
          </div>
          <div class="header-comments">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="commentPopUpItems"
                :isNormal="true"
                :data-model="model"
                :deliveryAddressClicked="undefined"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-comments'"
                ref="gc-header-comments"
                :valueChangeCallBack="headerFormValueChanged"
                :checkValid="isValid"
                :validationGroup="'gc-header-comments'"
                :scrollingEnabled="false"
              ></gc-form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="selectedIndex == 1" class="gc-details-grid">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <!-- :columns="getColumns" -->
            <dx-data-grid
              @toolbar-preparing="toolbarPreparing($event)"
              :data-source.sync="getDataSource"
              :height="getGridHeight"
              @cell-prepared="onCellPrepared"
              :ref="'dx-data-grid-comp'"
              :key="soDetailsCurrentView"
              @content-ready="onContentReady"
              @editor-preparing="onEditorPreparing"
              @editing-start="onEditingStart"
              @option-changed="onOptionChanged"
              :repaint-changes-only="true"
              :two-way-binding-enabled="true"
              :columnChooser="{
                enabled: false,
              }"
              @cell-click="onCellClick"
              @initialized="onDxGridInitialized"
              :focused-row-enabled="false"
              :selection="{
                mode: 'none',
              }"
            >
              <DxLoadPanel :show-indicator="false" :enabled="false" />
              <DxPaging :page-size="50" :enabled="false" />
              <DxPager :visible="false" />

              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preload-enabled="true"
                :renderAsync="false"
                :useNative="false"
              />

              <DxEditing
                :allow-updating="true"
                :allow-deleting="false"
                mode="cell"
                :use-icons="true"
                :refreshMode="'reshape'"
                :changes="changes"
              />

              <DxStateStoring
                :enabled="true"
                :storage-key="getPersistenceKey"
                type="localStorage"
              />
              <!-- Description -->
              <DxColumn
                data-field="Description"
                caption="Product / Account"
                :allow-editing="false"
                :min-width="420"
                cell-template="item-cell-template"
                :sort-order="'asc'"
                :sort-index="0"
              >
              </DxColumn>

              <!-- HasPromotion -->
              <DxColumn
                data-field="HasPromotion"
                caption=""
                :allow-editing="false"
                :cell-template="
                  (data, info) => {
                    if (info.data.HasPromotion)
                      return (data.innerHTML = `<i class='dx-icon dx-icon-money'></i>`);
                    else return data;
                  }
                "
                :width="50"
              >
              </DxColumn>

              <!-- SalesUM -->
              <DxColumn
                data-field="SalesUM"
                caption="UM"
                :allow-editing="baseView.mode != 'review'"
                :css-class="
                  baseView.mode != 'review'
                    ? 'edit-cell-textbox-field-1 gc-editable-cell-color'
                    : undefined
                "
                edit-cell-template="sales-um-edit-cell-template"
                :setCellValue="onSalesUMChanged"
              >
              </DxColumn>

              <!-- Quantity -->
              <DxColumn
                caption="Quantity"
                data-field="SalesUMQty"
                :allow-editing="baseView.mode != 'review'"
                :allow-sorting="false"
                :allow-search="false"
                format="##,###,###,###,##0.00"
                :css-class="
                  baseView.mode != 'review'
                    ? 'edit-cell-numberbox-field gc-editable-cell-color qty-cell'
                    : undefined
                "
                :setCellValue="onSalesUMQtyChanged"
                :editor-options="SalesUMQtyEditorOptions"
              />

              <!-- Price -->
              <DxColumn
                :caption="`Price (${model.CurrencyCode})`"
                data-field="SalesUMFXPrice"
                :allow-editing="allowEditingSalesUMFXPrice"
                :allow-sorting="false"
                :allow-search="false"
                format="##,###,###,###,##0.00"
                data-type="number"
                :css-class="
                  baseView.mode != 'review'
                    ? 'edit-cell-numberbox-field gc-editable-cell-color'
                    : undefined
                "
                :setCellValue="onSalesUMFXPriceChanged"
                :editor-options="SalesUMFXPriceEditorOptions"
              />
              <!-- Discount -->
              <DxColumn
                caption="Discount"
                data-field="DiscPcnt"
                :allow-editing="allowEditingDiscPcnt"
                :visible="visibleDiscPcnt"
                :show-in-column-chooser="visibleDiscPcnt"
                :allow-sorting="false"
                :allow-search="false"
                format="##0.00 '%'"
                :css-class="
                  baseView.mode != 'review' && visibleDiscPcnt
                    ? 'edit-cell-numberbox-field gc-editable-cell-color'
                    : undefined
                "
                :setCellValue="onDiscPcntChanged"
                :editor-options="DiscPcntEditorOptions"
              />
              <!-- Ex Total -->
              <DxColumn
                :caption="`Ex Total (${model.CurrencyCode})`"
                data-field="TaxableFXLineTotal"
                :allow-editing="false"
                format="##,###,###,###,##0.00"
                :allow-sorting="false"
                :allow-search="false"
              />
              <!-- Tax -->
              <DxColumn
                :caption="`Tax (${model.CurrencyCode})`"
                data-field="TaxFXLineTotal"
                :allow-editing="false"
                format="##,###,###,###,##0.00"
                :allow-sorting="false"
                :allow-search="false"
              />
              <!-- Inc Total -->
              <DxColumn
                :caption="`Inc Total (${model.CurrencyCode})`"
                data-field="FXLineTotal"
                :allow-editing="false"
                format="##,###,###,###,##0.00"
                :allow-sorting="false"
                :allow-search="false"
              />
              <!-- Available -->
              <DxColumn
                :caption="`Available`"
                data-field="Available"
                :allow-editing="false"
                format="##,###,###,###,##0.00"
                :allow-sorting="false"
                :allow-search="false"
                cell-template="available-cell-template"
              />
              <!-- Menu -->
              <DxColumn
                caption=""
                data-field=""
                :width="30"
                :max-width="30"
                :min-width="30"
                :allow-editing="false"
                cell-template="menu-cell-template"
                alignment="left"
                fixed-position="right"
                :fixed="true"
                :allow-sorting="false"
                :allow-search="false"
                css-class="more-menu"
                :allow-fixing="true"
                :allow-reordering="false"
              />

              <template #item-cell-template="{ data }">
                <div class="custom-auto-complete" @click="clickOnInfo(data)">
                  <span class="auto-complete-primary">
                    {{ data.data.Description }}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    {{ data.data.OriginItemCode }}
                  </span>
                </div>
              </template>

              <template #sales-um-edit-cell-template="{ data: cellInfo }">
                <div
                  v-bind:class="
                    cellInfo.data.SLUMLength < 2 ? 'cell-disabled' : 'sales-um'
                  "
                >
                  <DxTextBox
                    :value="cellInfo.value"
                    @focus-in="onSalesUMFocusIn($event, cellInfo)"
                    @initialized="onSalesUMInitialized"
                    class="edit-cell-textbox-field"
                    :readOnly="cellInfo.data.SLUMLength < 2"
                  />
                </div>
              </template>

              <template #available-cell-template="{ data }">
                <div>
                  <span
                    v-if="data.value < 0"
                    class="hyper-link"
                    @click="visibleStockLevel(data.data)"
                    >{{ data.text }}</span
                  >
                  <span
                    v-else
                    class="hyper-link color"
                    @click="visibleStockLevel(data.data)"
                  >
                    {{ data.text }}</span
                  >
                </div>
              </template>

              <template #menu-cell-template="{ data }">
                <DxDropDownButton
                  :items="[
                    { menuText: 'Line Comment', data: data },
                    { menuText: 'Item History', data: data },
                    {
                      menuText: 'GP Tool',
                      data: data,
                      visible: baseView.mode != 'review' && gpToolVisible,
                    },
                    {
                      menuText: 'Copy Line',
                      data: data,
                      visible: baseView.mode != 'review',
                    },
                  ]"
                  keyExpr="menuText"
                  displayExpr="menuText"
                  :drop-down-options="{ width: 250 }"
                  class="gc-dropdown-icon-button"
                  :id="data.data.ID"
                  :icon="'overflow'"
                  styling-mode="text"
                  :show-arrow-icon="false"
                  :onItemClick="onSoDetailsLineContextMenuItemClick"
                />
              </template>
            </dx-data-grid>
          </template>
          <template #rightContent>
            <div
              class="advance-filter-panel"
              :key="'fpanel-' + soDetailsCurrentView"
            >
              <DxToolbar class="split-view-toolbar">
                <dx-item
                  location="before"
                  widget="dxTabs"
                  :options="filterPanelTabOptions"
                  :selected-index.sync="sidebarTabSelectedIndex"
                ></dx-item>

                <DxItem
                  :options="filterToolbar.clear"
                  location="after"
                  locate-in-menu="auto"
                  widget="dxButton"
                  :visible="false"
                />

                <DxItem
                  :options="filterToolbar.close"
                  location="after"
                  widget="dxButton"
                />
              </DxToolbar>

              <div v-if="sidebarTabSelectedIndex == 0">
                <gc-filter-panel
                  v-if="sidebarTabSelectedIndex == 0"
                  :toolbarVisible="false"
                  :formItemData="filterFormItems"
                  :setGridPanelFilter="setGridPanelFilter"
                  :gridFoolter="showFooter"
                  :showLoading="showLoading"
                  :from="'touch-sales-order-filter'"
                  :isNormal="false"
                  :persistenceKey="getFilterPersistenceKey"
                  :key="'fp-' + soDetailsCurrentView + filterRefreshKey"
                  :overWriteClear="true"
                >
                </gc-filter-panel>
              </div>

              <div v-else>
                <gc-number-pad
                  :focusedCellData="focusedCellData"
                  :applyFocusClass="applyFocusClass"
                />
              </div>
            </div>
          </template>
        </gc-filter-split-view>
      </div>
      <GcFooter
        v-if="showFooter"
        v-bind:class="selectedIndex == 0 ? 't-so-foolter-h' : 't-so-foolter-d'"
      >
        <template #leftContent>
          <div
            class="gc-grid-footer-item left-content"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 4"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <GcPopUpSelectRecord
      v-if="popupVisible"
      :popupVisible="popupVisible"
      :popupHiddenCallBack="popupHiddenCallBack"
      :popupConfig="popupConfig"
      :dataModel="selectPopupModel"
    />

    <!-- Delivery Address -->
    <gc-popup
      v-if="editDeliveryAddressVisible"
      :popup-visible="editDeliveryAddressVisible"
      popup-title="Deliver To"
      :back-button-function="closeDeliveryAddressPopup"
      :popup-height="375"
      :saveButtonConfig="deliveryAddressPopupConfig.save"
      :backButtonConfig="deliveryAddressPopupConfig.back"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getDeliverToFormItems"
          :isNormal="true"
          :data-model="addressData"
          :formMode="baseView.mode"
          :fromFrom="'gc-header-form-d-a'"
          :formHeight="240"
        ></gc-form>
      </div>
    </gc-popup>

    <!-- Line Comment Popup  -->
    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="310"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="row css-v2 gc-popup-form">
        <form>
          <DxForm
            :ref="'line-comments-form'"
            :customizeItem="customizeLineCommentItem"
            :form-data.sync="lineCommentModel"
            :items="lineCommentItems"
            :label-location="formsConfig.labelPosition"
          ></DxForm>
        </form>
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- items history popup  -->
    <DxPopup
      :visible.sync="itemHistoryPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Customer Item History"
      :showCloseButton="false"
      :height="'75%'"
      @shown="itemHistoryPopupShown"
      @hidden="itemHistoryPopupHidden"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 transaction-list">
        <dx-data-grid
          :data-source="customerItemHistoryDataSourceConfig"
          :height="itemHistoryDataGridHeight"
          :columns="customerItemHistoryColumns"
          @toolbar-preparing="itemHistoryToolbarPreparing($event)"
          ref="itemHistoryGrid"
          :allow-column-reordering="false"
          :column-chooser="{ enabled: false }"
          @content-ready="itemHistoryAddGridNoResults($event)"
        >
          <template #historyStatusTemplate="{ data }">
            <gc-status-chip :status="data.data.Status" />
          </template>

          <template #date-in-cell-template="{ data }">
            <gc-friendly-date :date="data.data.DateIn" />
          </template>

          <template #displayDescription="{ data }">
            <div class="informer">
              <GcHeaderContentDynamic
                :baseView="baseView"
                :primaryLabel="customerItemHistory['Description']"
                :secondaryLabel="customerItemHistory['OriginItemCode']"
                :viewMode="'popup'"
              />
            </div>
          </template>
        </dx-data-grid>
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="itemHistoryPopupHidden"
        />
      </div>
    </DxPopup>

    <!-- GP Tool Popup  -->
    <DxPopup
      :visible.sync="gpToolPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      :title.sync="gpTool.title"
      :showCloseButton="false"
      :height="270"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="gp-toop-popup">
        <div class="row popup-in-header">
          <!-- <DxToolbar class="view-toolbar">
          <DxItem #default location="left" locate-in-menu="auto">-->
          <GcHeaderContentDynamic
            :baseView="baseView"
            :primaryLabel="gpTool.data['Description']"
            :secondaryLabel="gpTool.data['ItemCode']"
            :viewMode="'popup'"
          />
          <!-- </DxItem>
          </DxToolbar>-->
        </div>

        <div class="row css-v2 gc-popup-form">
          <form>
            <DxForm
              :form-data.sync="gpTool.model"
              :read-only="false"
              :show-colon-after-label="false"
              :show-required-mark="false"
              :show-validation-summary="false"
              :label-location="formsConfig.labelPosition"
              :customizeItem="customizeItem"
              :items="getGPToolFormItems"
              :validation-group="'gp-tool-form'"
              :height="95"
            ></DxForm>
          </form>
        </div>
      </div>

      <div class="footer">
        <DxButton
          text="Apply"
          type="default"
          styling-mode="contained"
          @click="applyGPToolValue"
          class="save-btn"
        />
        <DxButton
          text="Back"
          type="normal"
          styling-mode="contained"
          @click="popupHiddenCallBack(false)"
        />
      </div>
    </DxPopup>

    <!-- product details popup 460 -->
    <DxPopup
      :visible.sync="productDetailsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :title.sync="productDetails.title"
      :showCloseButton="false"
      :height="productDetails.hasPromotion ? 470 : 370"
      @hidden="itemDetailsPopupHidden"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-product-details' }"
    >
      <div class="product-details" v-show="productDetails.data != null">
        <div class="popup-in-header">
          <GcHeaderContentDynamic
            :baseView="baseView"
            :primaryLabel="productDetails.data['Description']"
            :secondaryLabel="productDetails.data['ItemCode']"
            :viewMode="'popup'"
          />
        </div>
        <div class="row details-row">
          <div class="col-6">
            <div
              v-show="productDetails.data.HasPrimaryImage == false"
              class="product-primary-image-img"
            >
              <div class="no-image">
                <span class="product-primary-image-label-secondary"
                  >No Image</span
                >
              </div>
            </div>
            <div
              v-show="productDetails.data.HasPrimaryImage == true"
              class="product-primary-image-img"
            >
              <img :src="productDetails.imageURL" width="auto" height="200" />
            </div>
          </div>
          <div class="col-6">
            <form>
              <DxForm
                ref="product-details-form"
                :form-data.sync="productDetails.model"
                :read-only="true"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :label-location="formsConfig.labelPosition"
                :customizeItem="customizeItem"
                :items="productDetailsItems"
                :height="productDetails.hasPromotion ? 320 : 220"
              ></DxForm>
            </form>
          </div>
        </div>
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="itemDetailsPopupHidden"
        />
      </div>
    </DxPopup>

    <!-- Available Stock -->
    <GcStockLevels
      v-if="visibleStockLevels"
      :itemData="stockLevelItemData"
      :setVisible="visibleStockLevels"
      :callBack="stockLevelCallBack"
    />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { CustomerService } from "../../../_services/api/customers/customer.service";
import { SalesRepresentativeService } from "../../../_services/api/sales/sales-rep.service";
import {
  getDecimalFormat,
  getFactorByCode,
  getGlobalField,
} from "../../../_store/helpers";
import { DefaultCompanyBranchDivisionService } from "../../../_services/api/sales/default-company-branch-dicision.service";
import { CompanyService } from "../../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../../_services/api/accounts/company-currency.service";
import { CommonStorage, FeatureStorage } from "../../../_services/storage";
import { BranchService } from "../../../_services/api/sales/branch.service";
import { DivisionService } from "../../../_services/api/sales/division.service";
import { SalesOrderTypeService } from "../../../_services/api/sales/sales-order-type.service";
import validationEngine from "devextreme/ui/validation_engine";
import { mapGetters } from "vuex";
import { CustomerDeliveryAddressService } from "../../../_services/api/customers/customer-delivery-address.service";
import { SalesOrderService } from "../../../_services/api/sales/sales-order.service";
import { SalesOrderV3Service } from "../../../_services/api/sales/sales-order-v3.service";
import ArrayStore from "devextreme/data/array_store";
import { ProductCategory1Service } from "../../../_services/api/settings/products/product-category-1.service";
import appConfig from "../../../app-config";
import salesFormulas from "../../../_helpers/formulas/sales-formulas";
import { SalesItemHistoryService } from "../../../_services/api/sales/sale-item-history.service";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";
import { alert } from "devextreme/ui/dialog";
// import { SalesOrderNoteService } from "../../../_services/api/sales/sales-order-note.service";
import { SalesOrderState } from "../../../_models/sales-order";
import { SalesOrderProductDetails } from "../../../_services/api/sales/sales-order-product-details.service";
import { PriceGroupService } from "../../../_services/api/sales/price-group.service";
import ApiService from "../../../_services/api/api.service";
import { ProductService } from "../../../_services/api/products/product.service";

import { DxColumn, DxDataGrid } from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";

const {
  calculateGrossProfitPcnt,
  calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  calculateSalesUMFXPriceFromSalesUMNetFXPrice,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = salesFormulas;

let soDetailsBaseRecord = {
  AddDiscPriceGroupCode: null,
  AddDiscPricingMethod: null,
  AddDiscPricingMethodValue: 0,
  AddDiscSalesUMPrice: 0,
  AddDiscStockUMPrice: 0,
  CalculatedDiscPcnt: 0,
  Comment: "",
  CustomerProduct: "",
  CustomerSalesContractCode: null,
  CustomerSalesContractLineNo: null,
  DiscFXLineTotal: 0,
  DiscLineTotal: 0,
  DiscPcnt: 0,
  ExTaxUnitCost: 0,
  FXLineTotal: 0,
  IsCommentVisible: false,
  IsPrimeCostItem: false,
  ItemCode: "",
  ItemType: "",
  KitVersion: 0,
  LineNo: 0,
  LineTotal: 0,
  NetFXLineTotal: 0,
  NetLineTotal: 0,
  PriceGroupCode: null,
  PriceGroupSalesUMPrice: 0,
  PriceGroupStockUMPrice: 0,
  PricingMethod: null,
  PricingMethodValue: null,
  RecordId: "00000000-0000-0000-0000-000000000000",
  RequiredByDate: null,
  SalesTaxPcnt: 0,
  SalesUM: "",
  SalesUMConversion: null,
  SalesUMCost: 0,
  SalesUMFXPrice: 0,
  SalesUMIsVariable: null,
  SalesUMManufacturedCost: 0,
  SalesUMNetFXPrice: 0,
  SalesUMNetPrice: 0,
  SalesUMPrice: 0,
  SalesUMPromotionNetPrice: 0,
  SalesUMQty: 0,
  SalesUMQtyFocused: false,
  SalesUMStandardCost: 0,
  SalesUMStandardPrice: 0,
  ShipDate: null,
  Status: "A",
  StockUM: null,
  StockUMFXPrice: 0,
  StockUMManufacturedCost: 0,
  StockUMNetFXPrice: 0,
  StockUMNetPrice: 0,
  StockUMPrice: 0,
  StockUMQty: 0,
  StockUMStandardCost: 0,
  StockUMStandardPrice: 0,
  TaxableFXLineTotal: 0,
  TaxableLineTotal: 0,
  TaxCode: null,
  TaxFXLineTotal: 0,
  TaxLineTotal: 0,
  WetFreightAdjustment: 0,
  WetFXFreightAdjustment: 0,
  WetFXLineTotal: 0,
  WetLineTotal: 0,
  WetPcnt: 0,
  HasPromotion: false,
  BestBeforeDate: null,
  ProductSizeCode: "",
  gpprcnt: 0,
  SalesUMSuppliedQty: 0,
};

let getFilterExpressionForArray = (fieldName, dataField, arr) => {
  let expression = "";
  for (let index = 0; index < arr.length; index++) {
    if (index == 0) {
      expression = `${fieldName} eq '` + arr[index][`${dataField}`] + "'";
    } else {
      expression =
        expression + ` or ${fieldName} eq '` + arr[index][`${dataField}`] + "'";
    }
  }
  return expression;
};

let chunkArray = (array, size) => {
  let result = [];
  for (let i = 0; i < array.length; i += size) {
    let chunk = array.slice(i, i + size);
    result.push(chunk);
  }
  return result;
};

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: { DxColumn, DxDataGrid },
  data() {
    return {
      timeOutID: undefined,
      priceUpdateTimeOut: undefined,
      discountTimeOut: undefined,
      loaded: false,
      setLoading: false,
      model: {
        CompanyCurrency: undefined,
        Status: "N",
        CustomStatus: undefined,
        FriendlyStatus: undefined,
        Code: null,

        // CustomerCode: null,
        CustomerCode: "13004",
        CustomerName: null,
        DateIn: new Date(),
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: null,

        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: null,
        DeliveryAddressState: null,
        DeliveryAddressStreetLine1: null,
        DeliveryAddressStreetLine2: null,
        DeliveryAddressSuburb: null,
        CustomerDeliveryAddressLineNo: undefined,

        ConsignmentNo: "",
        CurrencyCode: "",
        ExchangeRate: 1,

        BranchCode: null,
        BranchDescription: null,
        DivisionCode: null,
        DivisionDescription: null,
        SalesOrderTypeCode: null,
        SalesOrderTypeDescription: null,
        SalesRepresentativeCode: null,
        SalesRepresentativeFullName: null,

        SalesOrderDetails: [],

        DateChanged: null,
        DateCreated: null,
        ChangedBy: null,
        CreatedBy: null,
        Notes: [],
        LineItemCode: undefined,
        FilterDate: undefined,
      },
      selectedIndex: 0,

      popupVisible: false,
      popupConfig: undefined,
      selectPopupModel: {
        filterBySalesRep: undefined,
      },
      isValid: false,
      editDeliveryAddressVisible: false,
      addressData: undefined,
      soDetailsCurrentView: "CustomerList",
      // soDetailsCurrentView: "ProductList",
      showFooter: true,
      footerItems: [],
      changes: [],
      reviewDataList: new ArrayStore({
        key: "ID",
        data: [],
      }),
      showLeftContainer: true,
      showRightContainer: false,

      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.closeFilterPanel();
          },
          // visible: browserHelper.tablet,
        },
        clear: {
          text: "Clear",
          onClick: () => {
            this.clearAdvanceFilters();
          },
        },
      },
      sidebarTabSelectedIndex: 0,
      filterModel: {},
      selectedProductCategory1: [],
      filterCollection: [],
      focusedCellData: undefined,
      lineCommentsPopupVisible: false,

      lineCommentModel: {
        Comment: "",
        IsCommentVisible: false,
        ID: undefined,
        RowData: undefined,
      },

      itemHistoryPopupVisible: false,
      customerItemHistory: [],
      repaint: false,
      promoRequest: false,
      allowPriceChangeTriggerConfirmation: false,
      filterRefreshKey: 1,
      salesUMsLocalData: [],
      selectedRowData: undefined,
      gpToolPopupVisible: false,
      gpTool: {
        title: "GP Tool",
        data: [],
        cellInfo: undefined,
        model: {
          quantity: null,
          standardSell: null,
          currentPrice: null,
          gp: null,
          newSalesUMNetPrice: null,
        },
        //  items:  getGPToolFormItems
      },
      scrollingOffSet: undefined,
      localCopyItems: [],
      productDetailsPopupVisible: false,
      productDetails: {
        title: "Product Details",
        data: {
          HasPrimaryImage: false,
        },
        hasPromotion: false,
        imageURL: null,
        model: {
          itemCode: null,
          apn: null,
          standardSell: null,
          customerSell: null,
          cartonQty: null,
          salesUM: null,
          promotionStartDate: null,
          promotionEndDate: null,
        },
      },
      StockModel: {
        AvailableStock: false,
      },
      stockLevelItemData: undefined,
      visibleStockLevels: false,
      forceRefresh: true,
      productDataSourceItems: new ArrayStore({
        key: "ID",
        data: [],
      }),
      customerDataSourceItems: new ArrayStore({
        key: "ID",
        data: [],
      }),
      itemHistoryDataGridHeight: "auto",
      userDefaultSalesRep: undefined,
      priceChangeTimeId: undefined,
    };
  },
  beforeDestroy() {
    this.reviewDataList.clear();
    var views = [
      {
        value: "Review",
        text: "Review",
      },
      {
        value: "ProductList",
        text: "Product",
      },
      {
        value: "CustomerList",
        text: "Customer",
      },
    ];
    views.forEach((element) => {
      CommonStorage.clear("t-sales-order-" + element.value);
      CommonStorage.clear("t-sales-order-" + element.value + "-scroll-offset");
      CommonStorage.clear("filter-panel-t-sales-order-" + element.value);
    });
    CommonStorage.clear("t-sales-order-details");
    CommonStorage.clear("t-sales-order-details-scroll-offset");
    CommonStorage.clear("filter-panel-t-sales-order-details");
  },
  async created() {
    // this.loaded = true;

    this.$store.dispatch("ui/setVisibleCommentLabels", false);
    this.showLoading(true);

    if (CommonStorage.getItems(this.getFilterPersistenceKey + "-scroll-offset"))
      this.scrollingOffSet = JSON.parse(
        CommonStorage.getItems(this.getFilterPersistenceKey + "-scroll-offset")
      );

    await SettingsService.getBySettingByApplicationFeatureCode(
      "SalesOrder"
    ).then((res) => {
      res.data.value.forEach((element) => {
        if (element.SettingName == "PriceChangeTriggerConfirmation") {
          if (element.ScopeCode == "Global") {
            if (element.SettingValue == "Y")
              this.allowPriceChangeTriggerConfirmation = true;
          }
        }
      });
    });
    await this.initialized();

    // this.loadCustomerItems(undefined, 0);
    // this.loadProductItems(undefined, 150);
  },
  async mounted() {},

  computed: {
    DiscPcntEditorOptions() {
      return {
        format: "##0.00 '%'",
        elementAttr: {
          class: "gc-grid-number-box-editor",
        },
        onFocusIn: (e, cellInfo) => {
          if (this.focusedCellData) {
            this.removeCellFocus();
          }
          e.element.parentElement.classList.add("key-pad-focused-cell");
          e.event.target.select();
          this.onSalesUMQtyFocusIn(e, cellInfo);
          // e.element.classList.add("key-pad-focused");

          // // PriceLookUp on QTY change
          // if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
          //   this.getAvailableLookups("TiggerPriceLookUp").forEach(
          //     (element) => {
          //       this.updatePriceData(element, element);
          //     }
          //   );
          // }

          // // Update Values on SalesUMFXPrice change
          // if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
          //   this.getAvailableLookups("TriggerPriceUpdate").forEach(
          //     (element) => {
          //       var newData = this.onPriceUpdateValidateGPToolPrcnt(
          //         element,
          //         element.SalesUMFXPrice,
          //         element
          //       );
          //       this.updateDataSource(newData, element);
          //     }
          //   );
          // }

          // // Update Values on DiscPcnt change
          // if (
          //   this.getAvailableLookups("TriggerDiscountUpdate").length > 0
          // ) {
          //   this.getAvailableLookups("TriggerDiscountUpdate").forEach(
          //     (element) => {
          //       this.onDiscountPrctUpdate(
          //         element,
          //         element.DiscPcnt,
          //         element
          //       );
          //     }
          //   );
          // }
        },
      };
    },
    SalesUMFXPriceEditorOptions() {
      return {
        format: "##,###,###,###,##0.00",
        elementAttr: {
          class: "gc-grid-number-box-editor",
        },
        onFocusIn: (e, cellInfo) => {
          if (this.focusedCellData) {
            this.removeCellFocus();
          }
          e.event.target.select();
          e.element.parentElement.classList.add("key-pad-focused-cell");
          this.onSalesUMQtyFocusIn(e, cellInfo);

          // edit-cell-numberbox-field gc-editable-cell-color
          // edit-cell-numberbox-field gc-editable-cell-color dx-editor-cell key-pad-focused-cell dx-focused
          // edit-cell-numberbox-field gc-editable-cell-color dx-editor-cell

          // setTimeout(() => {
          //   this.onSalesUMQtyFocusIn(e, cellInfo);
          // }, 1);

          // // PriceLookUp on QTY change
          // if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
          //   this.getAvailableLookups("TiggerPriceLookUp").forEach(
          //     (element) => {
          //       this.updatePriceData(element, element);
          //     }
          //   );
          // }

          // // Update Values on SalesUMFXPrice change
          // if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
          //   this.getAvailableLookups("TriggerPriceUpdate").forEach(
          //     (element) => {
          //       var newData = this.onPriceUpdateValidateGPToolPrcnt(
          //         element,
          //         element.SalesUMFXPrice,
          //         element
          //       );
          //       this.updateDataSource(newData, element);
          //     }
          //   );
          // }

          // // Update Values on DiscPcnt change
          // if (
          //   this.getAvailableLookups("TriggerDiscountUpdate").length > 0
          // ) {
          //   this.getAvailableLookups("TriggerDiscountUpdate").forEach(
          //     (element) => {
          //       this.onDiscountPrctUpdate(
          //         element,
          //         element.DiscPcnt,
          //         element
          //       );
          //     }
          //   );
          // }
        },
      };
    },
    SalesUMQtyEditorOptions() {
      return {
        format: "##,###,###,###,##0.00",
        elementAttr: {
          class: "gc-grid-number-box-editor",
        },
        onFocusIn: (e, cellInfo) => {
          if (this.focusedCellData) {
            this.removeCellFocus();
          }
          e.event.target.select();
          this.onSalesUMQtyFocusIn(e, cellInfo);
          e.element.parentElement.classList.add("key-pad-focused-cell");
          // // e.element.classList.add("key-pad-focused");

          // // PriceLookUp on QTY change
          // if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
          //   this.getAvailableLookups("TiggerPriceLookUp").forEach(
          //     (element) => {
          //       this.updatePriceData(element, element);
          //     }
          //   );
          // }

          // // Update Values on SalesUMFXPrice change
          // if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
          //   this.getAvailableLookups("TriggerPriceUpdate").forEach(
          //     (element) => {
          //       var newData = this.onPriceUpdateValidateGPToolPrcnt(
          //         element,
          //         element.SalesUMFXPrice,
          //         element
          //       );
          //       this.updateDataSource(newData, element);
          //     }
          //   );
          // }

          // // Update Values on DiscPcnt change
          // if (
          //   this.getAvailableLookups("TriggerDiscountUpdate").length > 0
          // ) {
          //   this.getAvailableLookups("TriggerDiscountUpdate").forEach(
          //     (element) => {
          //       this.onDiscountPrctUpdate(
          //         element,
          //         element.DiscPcnt,
          //         element
          //       );
          //     }
          //   );
          // }
        },
      };
    },
    visibleDiscPcnt() {
      return FeatureStorage.checkPermission(
        "SalesOrderDetailEditDiscount",
        "edit"
      );
    },
    allowEditingDiscPcnt() {
      return (
        this.baseView.mode != "review" &&
        FeatureStorage.checkPermission("SalesOrderDetailEditDiscount", "edit")
      );
    },
    allowEditingSalesUMFXPrice() {
      return (
        this.baseView.mode != "review" &&
        FeatureStorage.checkPermission("SalesOrderDetailEditPrice", "edit")
      );
    },
    ...mapGetters({ commentPopUpItems: "ui/getCommentPopUpItems" }),
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({
      numericValue: "numericInputStore/getNumericValue",
      sourceNumericValue: "numericInputStore/getSourceNumericValue",
      sourceNumericRecord: "numericInputStore/getSourceNumericRecord",
      fieldFocused: "numericInputStore/getFieldFocused",
      keyPadLastEntry: "numericInputStore/getLastEntry",
    }),
    gpToolVisible() {
      return FeatureStorage.checkPermission("GP Tool", "create");
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "DateIn",
                  label: {
                    text: "Date In",
                  },
                  dataField: "DateIn",
                  required: true,
                  editorOptions: {
                    onValueChanged: this.onDateInValueChanged.bind(this),
                  },
                },
                {
                  screenField: "RequiredDate",
                  label: {
                    text: "Reqd Date",
                  },
                  dataField: "RequiredByDate",
                  required: true,
                  editorOptions: {
                    onValueChanged:
                      this.onRequiredByDateValueChanged.bind(this),
                  },
                },
                {
                  screenField: "ShipDate",
                  label: {
                    text: "Ship Date",
                  },
                  dataField: "ShipDate",
                  required: true,
                  editorOptions: {
                    // onValueChanged: this.onShipDateValueChanged.bind(this),
                  },
                },
                {
                  screenField: "CustPO",
                  dataField: "OrderNo",
                  editorOptions: {
                    // onValueChanged: this.onOrderNoChanged.bind(this),
                  },
                },
                {
                  itemType: "group",
                  caption: "",
                  cssClass: "deliver-to",
                  items: [
                    {
                      // screenField: "DeliverTo",
                      dataField: "DeliveryAddressCompanyName",
                      label: {
                        text: "Deliver To",
                      },
                      ref: "DeliveryAddressCompanyName",
                      required: true,
                      editorOptions: {
                        // onItemClick: this.onDeliveryAddressChanged.bind(this),
                        onFocusIn: async (e) => {
                          let validationResult =
                            await validationEngine.validateGroup(
                              "gc-form-header-toolbar"
                            );
                          if (!validationResult.isValid)
                            this.displayValidationSummary(
                              validationResult.brokenRules
                            );
                          else this.setPopupVisible(e, "DeliverTo");
                        },
                      },
                      dataSourceConfig: {
                        // data: deliveryAddressDataSourceItems,
                      },
                      visible: this.baseView.mode != "review",
                    },
                    {
                      screenField:
                        this.baseView.mode != "review"
                          ? "DeliverTo"
                          : undefined,
                      dataField: "DeliveryAddressCompanyName",
                      ref: "DeliveryAddressCompanyName",
                      label: {
                        text: "Deliver To",
                      },
                      required: true,
                      visible: this.baseView.mode == "review",
                    },
                    {
                      screenField: "DeliveryCompanyView",
                      editAddress:
                        this.baseView.mode != "review" ? true : false,
                    },
                  ],
                },
                // {
                //   screenField: "CurrencyCode",
                //   dataField: "CurrencyCode",
                // },
                // {
                //   screenField: "ExchangeRate",
                //   dataField: "ExchangeRate",
                // },
              ],
            },

            {
              itemType: "group",
              caption: "",
              items: [
                {
                  label: {
                    text: "Branch",
                  },
                  dataField:
                    this.baseView.mode != "review"
                      ? "BranchDescription"
                      : "Branch.Description",
                  required: true,
                  editorOptions: {
                    onValueChanged: async (e) => {
                      await this.getSalesUMs(this.model.BranchCode);
                      this.triggerPriceChange(e);
                    },
                    onFocusIn: (e) => {
                      this.setPopupVisible(e, "Branch");
                    },
                    showClearButton: true,
                  },
                },
                {
                  label: {
                    text: "Division",
                  },
                  dataField:
                    this.baseView.mode != "review"
                      ? "DivisionDescription"
                      : "Division.Description",
                  required: true,
                  editorOptions: {
                    onValueChanged: this.triggerPriceChange.bind(this),
                    onFocusIn: (e) => {
                      this.setPopupVisible(e, "Division");
                    },
                    showClearButton: true,
                  },
                },
                {
                  dataField:
                    this.baseView.mode != "review"
                      ? "SalesOrderTypeDescription"
                      : "SalesOrderType.Description",
                  label: {
                    text: "SO Type",
                  },
                  required: true,
                  editorOptions: {
                    onValueChanged: (e) => {
                      this.triggerPriceChange(e);
                    },
                    onFocusIn: (e) => {
                      this.setPopupVisible(e, "SalesOrderType");
                    },
                    showClearButton: true,
                  },
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: {
                    text: "Sales Rep",
                  },
                  required: true,
                  editorOptions: {
                    onFocusIn: (e) => {
                      this.setPopupVisible(e, "SalesRep");
                    },
                    showClearButton: true,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    isSaveEnable() {
      if (this.baseView.mode == "create") return true;
      else {
        if (!this.loaded) return true;
        else if (this.model.Status == "C" || this.model.Status == "X")
          return false;
        else return true;
      }
    },
    getHeaderToolbar() {
      return {
        audit: this.baseView.mode == "review",
        status: true,
        notes: false,
        save: this.isSaveEnable,
        editURL: "/t-sales-order",
        editCallBack: this.editSOCallBack,
        saveOptions: {
          items:
            this.baseView.mode != "create"
              ? [
                  {
                    text: "Draft",
                    id: "D",
                    visible: this.model.Status == "D",
                  },
                  {
                    text: "Commit",
                    id: "A",
                    default: true,
                    visible: this.model.Status !== "H",
                  },
                  {
                    text: "Cancel",
                    id: "X",
                    visible: this.model.InvoiceCode == 0,
                  },
                ]
              : [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                ],
          keyExpr: "id",
          displayExpr: "text",
          dropDownOptions: {
            width: "150px",
          },
          saveKey: "NextStatus",
        },
        // saveCallback: this.saveSalesOrder,
        screenName: "Sales Orders - All",
        pdf: this.baseView.mode == "review",

        toolbarFormItems: [
          {
            // screenField: "Customer",
            dataField: "CustomerName",
            cssClass: "toolbar-customer-label",
            editorOptions: {
              dropDownOptions: {
                minWidth: 300,
                elementAttr: {
                  id: "so-v4-customer-details",
                },
              },
              width: 300,
              placeholder: "Customer Name",
              showClearButton: true,
              // onItemClick: this.onCustomerCodeItemClicked.bind(this),
              elementAttr: {
                id: "so-v4-customer-name",
              },
              onFocusIn: (e) => {
                this.setPopupVisible(e, "Customer");
              },
              onValueChanged: this.onCustomerValueChanged,
            },
            label: {
              text: "Customer",
              visible: false,
            },
            required: true,
            visible: this.baseView.mode != "review",
          },
        ],
        // formContentReady: this.toolBarFormContentReady,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
        customStatus: {
          enabled: true,
          key: "CustomStatus",
        },
      };
    },
    getTabs() {
      return [
        {
          text: "Header",
          path: `/t-sales-order/${this.baseView.mode}/${this.baseView.id}/header`,
          applicationFeatureCode: "SalesOrder",
          ignoreRouteChange: true,
          onClick: this.onTabClick,
        },
        {
          text: "Details",
          path: `/t-sales-order/${this.baseView.mode}/${this.baseView.id}/details`,
          applicationFeatureCode: "SalesOrder",
          ignoreRouteChange: true,
          onClick: this.onTabClick,
        },
      ];
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getDeliverToFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "DeliveryAddressCompanyName",
              editorType: "dxTextBox",
              label: {
                text: "Name",
              },
              editorOptions: {
                maxLength: "100",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressStreetLine1",
              dataField: "DeliveryAddressStreetLine1",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressStreetLine2",
              dataField: "DeliveryAddressStreetLine2",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressSuburb",
              dataField: "DeliveryAddressSuburb",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressState",
              dataField: "DeliveryAddressState",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressPostcode",
              dataField: "DeliveryAddressPostcode",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
            {
              screenField: "PhysicalAddressCountry",
              dataField: "DeliveryAddressCountry",
              editorOptions: {
                maxLength: "50",
                readOnly:
                  this.model.Status === "C" || this.model.Status === "X",
              },
              // allowUpdate: false,
            },
          ],
        },
      ];
    },
    deliveryAddressPopupConfig() {
      return {
        save: {
          text: "Save",
          disabled: !this.deliveryAddressFormIsDirty,
          clickCallback: async () => {
            await this.updateDeliveryAddress();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            this.closeDeliveryAddressPopup();
          },
        },
      };
    },
    deliveryAddressFormIsDirty() {
      if (!this.model) return false;

      return (
        this.model.DeliveryAddressCompanyName !==
          this.addressData.DeliveryAddressCompanyName ||
        this.model.DeliveryAddressStreetLine1 !==
          this.addressData.DeliveryAddressStreetLine1 ||
        this.model.DeliveryAddressStreetLine2 !==
          this.addressData.DeliveryAddressStreetLine2 ||
        this.model.DeliveryAddressSuburb !==
          this.addressData.DeliveryAddressSuburb ||
        this.model.DeliveryAddressState !==
          this.addressData.DeliveryAddressState ||
        this.model.DeliveryAddressPostcode !==
          this.addressData.DeliveryAddressPostcode ||
        this.model.DeliveryAddressCountry !==
          this.addressData.DeliveryAddressCountry
      );
    },

    // Details Tab
    getColumns() {
      return [
        {
          caption: "Product / Account",
          dataField: "Description",
          sortOrder: "asc",
          sortIndex: 0,
          cssClass: "class-item-cell-template",
          cellTemplate: "item-cell-template",
          // (data, info) => {
          //   return (data.innerHTML = `<div class="custom-auto-complete" @click="clickOnInfo(${info})">
          //               <span class="auto-complete-primary">
          //                 ${info.data.Description1}
          //               </span>
          //               <span class="record-secondary gc-grid-code">
          //                 ${info.data.OriginItemCode}
          //               </span>
          //             </div>`);
          // },
          allowEditing: false,
          minWidth: 420,
        },
        {
          caption: "",
          dataField: "HasPromotion",
          allowEditing: false,
          allowSorting: false,
          allowSearch: false,
          showInColumnChooser: false,
          allowHiding: false,
          width: 50,
          allowFiltering: false,

          cellTemplate: (data, info) => {
            if (info.data.HasPromotion)
              return (data.innerHTML = '<i class="dx-icon dx-icon-money"></i>');
            else return data;
          },
        },
        {
          caption: "ItemCode",
          dataField: "ItemCode",
          allowEditing: false,
          visible: false,
          showInColumnChooser: false,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          // showEditorAlways: this.dataViewType != "review",
          allowEditing: this.dataViewType != "review",
          allowSorting: false,
          cssClass:
            this.baseView.mode != "review"
              ? "edit-cell-textbox-field-1 gc-editable-cell-color"
              : undefined,
          editCellTemplate: "sales-um-edit-cell-template",
          setCellValue: (newData, value, currentRowData) => {
            newData.SalesUM = value;
            newData.SalesUMQty = currentRowData.SalesUMQty;
            var obj = { ...currentRowData, ...newData };

            return SalesOrderV3Service.setSaleItemPrice(
              newData,
              obj,
              this.model.SalesOrderTypeCode,
              this.model.BranchCode,
              this.model.CustomerCode,
              this.model.ExchangeRate,
              this.model.DateIn,
              this.model.RequiredByDate,
              false
            ).then((res) => {
              res = { ...currentRowData, ...res };
              newData = res;

              if (newData.SalesUMQty > 0) this.addToReview(newData);
            });
          },
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          allowEditing: this.baseView.mode != "review",
          allowSorting: false,
          allowSearch: false,
          // showEditorAlways: this.baseView.mode != "review",
          format: "##,###,###,###,##0.00",
          dataType: "number",
          cssClass:
            this.baseView.mode != "review"
              ? "edit-cell-numberbox-field gc-editable-cell-color qty-cell"
              : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.00",
            elementAttr: {
              class: "gc-grid-number-box-editor",
            },
            onFocusIn: (e, cellInfo) => {
              if (this.focusedCellData) {
                this.removeCellFocus();
              }
              e.event.target.select();
              this.onSalesUMQtyFocusIn(e, cellInfo);
              e.element.parentElement.classList.add("key-pad-focused-cell");

              // PriceLookUp on QTY change
              if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
                this.getAvailableLookups("TiggerPriceLookUp").forEach(
                  (element) => {
                    this.updatePriceData(element, element);
                  }
                );
              }

              // Update Values on SalesUMFXPrice change
              if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
                this.getAvailableLookups("TriggerPriceUpdate").forEach(
                  (element) => {
                    var newData = this.onPriceUpdateValidateGPToolPrcnt(
                      element,
                      element.SalesUMFXPrice,
                      element
                    );
                    this.updateDataSource(newData, element);
                  }
                );
              }

              // Update Values on DiscPcnt change
              if (
                this.getAvailableLookups("TriggerDiscountUpdate").length > 0
              ) {
                this.getAvailableLookups("TriggerDiscountUpdate").forEach(
                  (element) => {
                    this.onDiscountPrctUpdate(
                      element,
                      element.DiscPcnt,
                      element
                    );
                  }
                );
              }
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            if (this.timeOutID) clearTimeout(this.timeOutID);

            newData.SalesUMQty = value;
            newData.SalesUMQtyPreviousValue = currentRowData.SalesUMQty;
            newData.DiscPcnt = 0;
            newData.DiscPcntPreviousValue = 0;
            newData.TiggerPriceLookUp = true;
            newData.TriggerPriceUpdate = false;
            newData.TriggerDiscountUpdate = false;

            if (
              !currentRowData.SalesUMFXPricePreviousValue &&
              this.keyPadLastEntry.value == "clear"
            )
              newData.TiggerPriceLookUp = false;

            var obj = { ...currentRowData, ...newData };
            this.updateDataSource(newData, currentRowData);

            this.setUpdatePriceData(newData, obj);
          },
        },
        {
          caption: `Price (${this.model.CurrencyCode})`,
          dataField: "SalesUMFXPrice",
          allowEditing:
            this.baseView.mode != "review" &&
            FeatureStorage.checkPermission("SalesOrderDetailEditPrice", "edit"),
          // showEditorAlways: this.baseView.mode != "review",
          allowSorting: false,
          allowSearch: false,
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          cssClass:
            this.baseView.mode != "review" &&
            FeatureStorage.checkPermission("SalesOrderDetailEditPrice", "edit")
              ? "edit-cell-numberbox-field gc-editable-cell-color"
              : undefined,
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            elementAttr: {
              class: "gc-grid-number-box-editor",
            },
            onFocusIn: (e, cellInfo) => {
              if (this.focusedCellData) {
                this.removeCellFocus();
              }
              e.element.parentElement.classList.add("key-pad-focused-cell");
              e.event.target.select();
              this.onSalesUMQtyFocusIn(e, cellInfo);
              // e.element.classList.add("key-pad-focused");

              // PriceLookUp on QTY change
              if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
                this.getAvailableLookups("TiggerPriceLookUp").forEach(
                  (element) => {
                    this.updatePriceData(element, element);
                  }
                );
              }

              // Update Values on SalesUMFXPrice change
              if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
                this.getAvailableLookups("TriggerPriceUpdate").forEach(
                  (element) => {
                    var newData = this.onPriceUpdateValidateGPToolPrcnt(
                      element,
                      element.SalesUMFXPrice,
                      element
                    );
                    this.updateDataSource(newData, element);
                  }
                );
              }

              // Update Values on DiscPcnt change
              if (
                this.getAvailableLookups("TriggerDiscountUpdate").length > 0
              ) {
                this.getAvailableLookups("TriggerDiscountUpdate").forEach(
                  (element) => {
                    this.onDiscountPrctUpdate(
                      element,
                      element.DiscPcnt,
                      element
                    );
                  }
                );
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (this.priceUpdateTimeOut) clearTimeout(this.priceUpdateTimeOut);

            newData.SalesUMFXPrice = value;
            newData.TiggerPriceLookUp = false;
            newData.TriggerPriceUpdate = true;
            newData.TriggerDiscountUpdate = false;

            this.updateDataSource(newData, currentRowData);

            this.setPriceUpdate(newData, value, currentRowData);
          },
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          allowEditing:
            this.baseView.mode != "review" &&
            FeatureStorage.checkPermission(
              "SalesOrderDetailEditDiscount",
              "edit"
            ),
          visible: FeatureStorage.checkPermission(
            "SalesOrderDetailEditDiscount",
            "edit"
          ),
          showInColumnChooser: FeatureStorage.checkPermission(
            "SalesOrderDetailEditDiscount",
            "edit"
          ),
          allowSorting: false,
          allowSearch: false,
          format: "##0.00 '%'",
          cssClass:
            this.baseView.mode != "review" &&
            FeatureStorage.checkPermission(
              "SalesOrderDetailEditDiscount",
              "edit"
            )
              ? "edit-cell-numberbox-field gc-editable-cell-color"
              : undefined,
          editorOptions: {
            format: "##0.00 '%'",
            elementAttr: {
              class: "gc-grid-number-box-editor",
            },
            onFocusIn: (e, cellInfo) => {
              if (this.focusedCellData) {
                this.removeCellFocus();
              }
              e.element.parentElement.classList.add("key-pad-focused-cell");
              e.event.target.select();
              this.onSalesUMQtyFocusIn(e, cellInfo);
              // e.element.classList.add("key-pad-focused");

              // PriceLookUp on QTY change
              if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
                this.getAvailableLookups("TiggerPriceLookUp").forEach(
                  (element) => {
                    this.updatePriceData(element, element);
                  }
                );
              }

              // Update Values on SalesUMFXPrice change
              if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
                this.getAvailableLookups("TriggerPriceUpdate").forEach(
                  (element) => {
                    var newData = this.onPriceUpdateValidateGPToolPrcnt(
                      element,
                      element.SalesUMFXPrice,
                      element
                    );
                    this.updateDataSource(newData, element);
                  }
                );
              }

              // Update Values on DiscPcnt change
              if (
                this.getAvailableLookups("TriggerDiscountUpdate").length > 0
              ) {
                this.getAvailableLookups("TriggerDiscountUpdate").forEach(
                  (element) => {
                    this.onDiscountPrctUpdate(
                      element,
                      element.DiscPcnt,
                      element
                    );
                  }
                );
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (this.discountTimeOut) clearTimeout(this.discountTimeOut);

            this.$nextTick(() => {
              setTimeout(() => {
                this.applyFocusClass();
              }, 100);
            });

            newData.DiscPcnt = value;
            if (currentRowData.SalesUMQty > 0) {
              newData.TiggerPriceLookUp = false;
              newData.TriggerPriceUpdate = false;
              newData.TriggerDiscountUpdate = true;

              this.updateDataSource(newData, currentRowData);

              this.setDiscountUpdate(newData, value, currentRowData);
            }
          },
        },
        {
          caption: "GP %",
          dataField: "gpprcnt",
          allowSorting: false,
          allowSearch: false,
          visible: false,
          showInColumnChooser: false,
        },
        // {
        //   caption: 'Discount',
        // },
        // {
        //   caption: 'Net',
        // },
        {
          caption: `Ex Total (${this.model.CurrencyCode})`,
          dataField: "TaxableFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          allowSorting: false,
          allowSearch: false,
        },
        {
          caption: `Tax (${this.model.CurrencyCode})`,
          dataField: "TaxFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          allowSorting: false,
          allowSearch: false,
        },
        {
          caption: `Inc Total (${this.model.CurrencyCode})`,
          dataField: "FXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          allowSorting: false,
          allowSearch: false,
        },
        {
          caption: "Available",
          dataField: "Available",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          cellTemplate: "available-cell-template",
          allowSearch: false,
        },
        {
          caption: "",
          dataField: "",
          width: 30,
          minWidth: 30,
          maxWidth: 30,
          allowEditing: false,
          cellTemplate: "menu-cell-template",
          alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
          allowReordering: false,
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          allowGrouping: false,
        },
      ];
    },
    getDataSource() {
      // return this.productDataSourceItems;
      if (this.soDetailsCurrentView == "ProductList") {
        // return this.productListPostProcess(this.productDataSourceItems._array);
        // return this.productDataSourceItems;
        // return {
        //   store: this.productDataSourceItems,
        //   reshapeOnPush: true,
        // }
        return new DataSource({
          store: this.productDataSourceItems,
          postProcess: this.productListPostProcess,
        });
      }
      // return this.getProductList;
      else if (this.soDetailsCurrentView == "CustomerList") {
        // return this.productListPostProcess(this.customerDataSourceItems._array);
        // return this.getCustomerList;
        // return this.customerDataSourceItems;
        return new DataSource({
          store: this.customerDataSourceItems,
          postProcess: this.productListPostProcess,
        });
      } else {
        // return this.reviewDataList;
        return new DataSource({
          store: this.reviewDataList,
          postProcess: this.productListPostProcess,
        });
      }
    },
    getGridHeight() {
      return this.gridHeight - 20 - 40 - 55;
      // 20 => Top & Bottom Padding
      // 40 => Footer Height
      // 55 => Toolbar Height + Toolbar bottom padding
    },
    getProductList() {
      var filter = [
        [
          ["ItemType", "=", "S"],
          "and",
          ["IsDefault", "=", "Y"],
          "and",
          ["AvailableForSale", "=", "Y"],
        ],
        "and",
        [
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];
      if (this.model.BranchCode) {
        filter[2].push("and");
        filter[2].push(["BranchCode", "=", this.model.BranchCode]);
      }
      return SalesOrderService.dataSourceConfig(
        "api/ProductFilterGroupSaleItemCompanyBranch",
        {
          filter: filter,
          count: true,
          key: "ItemCode",
          postProcess: (data) => {
            var items = [];
            data.forEach((element) => {
              element.Origin = "Product";
              element.SalesUMQty = 0;
              element.SalesUMFXPrice = 0;
              element.TaxableFXLineTotal = 0;
              element.TaxFXLineTotal = 0;
              element.FXLineTotal = 0;
              element.HasPromotion = false;
              element = { ...soDetailsBaseRecord, ...element };

              element.ID = element.ItemCode;
              element.OriginItemCode = element.ItemCode;

              var i = this.reviewDataList._array.findIndex(
                (x) => x.ID == element.ID
              );

              var item = undefined;
              var ums = [];
              if (i == -1) item = element;
              else {
                this.updateReviewList({
                  HasPromotion: false,
                  ID: this.reviewDataList._array[i].ID,
                });
                item = this.reviewDataList._array[i];
              }

              this.salesUMsLocalData.forEach((um) => {
                if (um.ItemCode == item.ItemCode) ums.push(um);
              });

              item.SLUMLength = ums.length;
              item.SalesUMs = ums;

              items.push(item);

              this.localCopyItems.forEach((copy) => {
                if (copy.OriginItemCode == item.ItemCode) {
                  var c_i = this.reviewDataList._array.findIndex(
                    (x) => x.ID == copy.ID
                  );

                  if (c_i != -1) {
                    this.updateReviewList({
                      HasPromotion: false,
                      ID: this.reviewDataList._array[c_i].ID,
                    });
                    items.push(this.reviewDataList._array[c_i]);
                  } else {
                    items.push(copy);
                  }
                }
              });
            });

            this.setItemPromotions(items);
            return items;
          },
        }
      );
    },
    getCustomerList() {
      var filter = [
        [["ItemType", "=", "S"], "and", ["IsDefault", "=", "Y"]],
        "and",
        [
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];
      if (this.model.BranchCode) {
        filter[2].push("and");
        filter[2].push(["BranchCode", "=", this.model.BranchCode]);
      }

      return SalesOrderService.dataSourceConfig(
        "api/CustomerSaleItemCompanyBranch",
        {
          key: "ItemCode",
          filter: filter,
          postProcess: (data) => {
            var items = [];
            data.forEach((element) => {
              element.Origin = "Customer";
              element.SalesUMQty = 0;
              element.SalesUMFXPrice = 0;
              element.TaxableFXLineTotal = 0;
              element.TaxFXLineTotal = 0;
              element.FXLineTotal = 0;
              element.HasPromotion = false;

              element = { ...soDetailsBaseRecord, ...element };

              element.ID = element.ItemCode;
              element.OriginItemCode = element.ItemCode;

              var i = this.reviewDataList._array.findIndex(
                (x) => x.ID == element.ID || x.ProductCode == element.ID
              );

              var item = undefined;
              var ums = [];
              if (i == -1) item = element;
              else {
                this.updateReviewList({
                  HasPromotion: false,
                  ID: this.reviewDataList._array[i].ID,
                });
                item = this.reviewDataList._array[i];
                // return;
              }

              this.salesUMsLocalData.forEach((um) => {
                if (um.ItemCode == item.OriginItemCode) ums.push(um);
              });

              item.SLUMLength = ums.length;
              item.SalesUMs = ums;

              // if(item.ItemCode != "CON10PETPOUCH")
              items.push(item);

              this.localCopyItems.forEach((copy) => {
                if (
                  copy.OriginItemCode == item.ItemCode ||
                  copy.ProductCode == item.OriginItemCode
                ) {
                  var c_i = this.reviewDataList._array.findIndex(
                    (x) => x.ID == copy.ID
                  );

                  if (c_i != -1) {
                    this.updateReviewList({
                      HasPromotion: false,
                      ID: this.reviewDataList._array[c_i].ID,
                    });
                    items.push(this.reviewDataList._array[c_i]);
                  } else {
                    items.push(copy);
                  }
                }
              });
            });
            this.setItemPromotions(items);
            return items;
          },
        }
      );
    },
    getDefaultFilters() {
      if (this.soDetailsCurrentView == "ProductList") {
        let filter = [
          [
            ["ItemType", "=", "S"],
            "and",
            ["IsDefault", "=", "Y"],
            "and",
            ["AvailableForSale", "=", "Y"],
          ],
          "and",
          [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["Inactive", "=", "N"],
          ],
        ];
        if (this.model.BranchCode) {
          filter[2].push("and");
          filter[2].push(["BranchCode", "=", this.model.BranchCode]);
        }

        return filter;
      } else if (this.soDetailsCurrentView == "CustomerList") {
        let filter = [
          [["ItemType", "=", "S"], "and", ["IsDefault", "=", "Y"]],
          "and",
          [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["Inactive", "=", "N"],
          ],
        ];
        if (this.model.BranchCode) {
          filter[2].push("and");
          filter[2].push(["BranchCode", "=", this.model.BranchCode]);
        }

        return filter;
      } else {
        return undefined;
      }
    },
    getPersistenceKey() {
      if (this.soDetailsCurrentView == "Review") {
        return (
          "t-sales-order-" +
          this.soDetailsCurrentView +
          "_" +
          appConfig.VUE_APP_COOKIE_NAME
        );
      } else {
        return "t-sales-order-details_" + appConfig.VUE_APP_COOKIE_NAME;
      }
    },
    getFilterPersistenceKey() {
      // return "t-sales-order-" + this.soDetailsCurrentView;
      if (this.soDetailsCurrentView == "Review") {
        return "t-sales-order-" + this.soDetailsCurrentView;
      } else {
        return "t-sales-order-details";
      }
    },
    lineCommentItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "Comment",
                  editorType: "dxTextArea",
                  label: { visible: false },
                  editorOptions: {
                    height: "140",
                    maxLength: 1000,
                  },
                },
                {
                  dataField: "IsCommentVisible",
                  label: { text: "Visible On Invoice" },
                  editorType: "dxSwitch",
                },
              ],
            },
          ],
        },
      ];
    },
    customerItemHistoryDataSourceConfig() {
      if (!this.model.CustomerCode || !this.model.LineItemCode) {
        return;
      } else {
        return SalesItemHistoryService.dataSourceConfig({
          // select: ["Note", "LineNo", "SalesOrderCode"],
          sort: [{ selector: "SalesOrderCode", desc: true }],
          filter: [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["ItemType", "=", "S"],
            "and",
            ["ItemCode", "=", this.model.LineItemCode],
          ],
        });
      }
    },
    customerItemHistoryColumns() {
      return [
        {
          caption: "Order",
          dataField: "SalesOrderCode",
          alignment: "left",
          width: 130,
        },
        {
          caption: "Date",
          dataField: "DateIn",
          width: 150,
          cellTemplate: "date-in-cell-template",
          allowFiltering: false,
        },
        {
          caption: "Qty",
          dataField: "SalesUMQty",
          alignment: "right",
          format: getDecimalFormat("Decimal-16-2").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          alignment: "left",
          width: 100,
        },
        {
          caption: "Unit Price",
          dataField: "SalesUMNetPrice",
          alignment: "right",
          // format: this.getDecimalFormatByCode(13).Format,
          format: getDecimalFormat("Decimal-16-4C").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "Status",
          dataField: "FriendlyStatus",
          cellTemplate: "historyStatusTemplate",
          width: 100,
        },
        {
          caption: "Price Group",
          dataField: "PriceGroupDescription",
          alignment: "left",
        },
      ];
    },

    // GP Tool
    getGPToolFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCound: 1,
              items: [
                {
                  dataField: "quantity",
                  editorType: "dxNumberBox",
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  dataField: "standardSell",
                  label: {
                    text: this.getStandardSellLabel,
                  },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    format: getDecimalFormat("Decimal-16-4C").ReadOnlyFormat,
                    readOnly: true,
                  },
                },
                {
                  dataField: "currentPrice",
                  label: {
                    text: this.getCurrentPriceLabel,
                  },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    format: getDecimalFormat("Decimal-16-4C").ReadOnlyFormat,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCound: 1,
              items: [
                {
                  dataField: "gp",
                  label: {
                    text: "GP %",
                  },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    format: getDecimalFormat("Decimal-16-4").EditFormat,
                    onChange: this.gpPercentageChange.bind(this),
                    onValueChanged: this.onGpValueChanged,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  dataField: "newSalesUMNetPrice",
                  label: {
                    text: this.getGPToolNewPriceLable,
                  },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    format: getDecimalFormat("Decimal-16-4C").EditFormat,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onChange: this.gpNewPriceChange.bind(this),
                  },
                },
              ],
            },
          ],
        },
      ];

      return items;
    },
    getStandardSellLabel() {
      return `Std Sell (${this.model.CurrencyCode})`;
    },
    getCurrentPriceLabel() {
      return `Current Price (${this.model.CurrencyCode})`;
    },
    getGPToolNewPriceLable() {
      return `New Price (${this.model.CurrencyCode})`;
    },

    // Item Details
    productDetailsItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "apn",
              label: {
                text: "APN",
              },
              editorType: "dxTextBox",
            },
            {
              dataField: "standardSell",
              // gcType: "Decimal-4-2C",
              label: {
                text: "Standard Sell",
              },
              editorType: "dxNumberBox",
              editorOptions: {
                format: getDecimalFormat("Decimal-16-2C").ReadOnlyFormat,
                readOnly: true,
              },
            },
            {
              dataField: "customerSell",
              // gcType: "Decimal-4-2C",
              label: {
                text: "Customer Sell",
              },
              editorType: "dxNumberBox",
              editorOptions: {
                format: getDecimalFormat("Decimal-16-2C").ReadOnlyFormat,
                readOnly: true,
              },
            },
            {
              dataField: "promotionStartDate",
              label: {
                text: "Promotion Start Date",
              },
              // gcType: "Date",
              editorType: "dxDateBox",
              visible: this.productDetails.hasPromotion,
              editorOptions: {
                displayFormat: "dd MMM yyyy",
              },
            },
            {
              dataField: "promotionEndDate",
              label: "Promotion End Date",
              // gcType: "Date",
              editorType: "dxDateBox",
              visible: this.productDetails.hasPromotion,
              editorOptions: {
                displayFormat: "dd MMM yyyy",
              },
            },
            {
              dataField: "cartonQty",
              label: {
                text: "Carton Quantity",
              },
              // gcType: "String",
              editorType: "dxTextBox",
            },
            {
              dataField: "salesUM",
              label: {
                text: "Sales UM",
              },
              // gcType: "String",
              editorType: "dxTextBox",
            },
          ],
        },
      ];
    },

    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SupplierRequired",
          location: "left",
          label: "Line Count",
          value: 0,
          customCalc: (headerData, gridItems) => {
            var count = 0;
            gridItems.forEach((element) => {
              if (element.ItemCode) count++;
            });

            return count;
          },
        },
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMQty",
          location: "left",
          value: 0,
        },
        {
          screenField: "FXLineTotal",
          dataField: "TaxableFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Total (${this.model.CurrencyCode})`,
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },

    // filter side panel
    filterPanelTabOptions() {
      return {
        dataSource: [
          {
            id: 0,
            text: "Filters",
          },
          {
            id: 1,
            text: "Number Pad",
          },
        ],
        onItemClick: this.changeFilterPanelTab,
        selectedIndex: this.sidebarTabSelectedIndex,
      };
    },
    filterFormItems() {
      return [
        {
          screenField: "ProductCategory1",
          touchEnabled: true,
          editorOptions: {
            touchEnabled: true,
          },
        },
        {
          screenField: "ProductCategory2",
          touchEnabled: true,
          editorOptions: {
            touchEnabled: true,
          },
        },
        {
          screenField: "ProductCategory3",
          touchEnabled: true,
          editorOptions: {
            touchEnabled: true,
          },
        },
        {
          screenField: "ProductCategory4",
          touchEnabled: true,
          editorOptions: {
            touchEnabled: true,
          },
        },
        {
          screenField: "ProductType",
          touchEnabled: true,
          editorOptions: {
            touchEnabled: true,
          },
        },
      ];
    },
  },
  methods: {
    onDxGridInitialized(e) {
      var dataGrid = e.component.instance();
      dataGrid.option("loadPanel.enabled", false);
    },
    onSalesUMChanged(newData, value, currentRowData) {
      newData.SalesUM = value;
      newData.SalesUMQty = currentRowData.SalesUMQty;
      // var obj = { ...currentRowData, ...newData };

      SalesOrderV3Service.setSaleItemPrice(
        newData,
        currentRowData,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false
      ).then((res) => {
        res = { ...currentRowData, ...res };
        newData = res;

        this.localUpdate(currentRowData.ID, newData);

        // if (newData.SalesUMQty > 0) this.addToReview(newData);
      });
    },
    onSalesUMQtyChanged(newData, value, currentRowData) {
      if (this.timeOutID) clearTimeout(this.timeOutID);

      if (
        currentRowData.SalesUMSuppliedQty > 0 &&
        value < currentRowData.SalesUMSuppliedQty
      ) {
        this.qtyChangeWarning(currentRowData);
      } else {
        newData.SalesUMQty = value;
        newData.SalesUMQtyPreviousValue = currentRowData.SalesUMQty;
        newData.DiscPcnt = 0;
        newData.DiscPcntPreviousValue = 0;
        // newData.TiggerPriceLookUp = true;
        // newData.TriggerPriceUpdate = false;
        // newData.TriggerDiscountUpdate = false;

        if (
          !currentRowData.SalesUMFXPricePreviousValue &&
          this.keyPadLastEntry.value == "clear"
        ) {
          newData.TiggerPriceLookUp = false;
        }

        // var obj = { ...currentRowData, ...newData };
        this.timeOutID = setTimeout(() => {
          SalesOrderV3Service.setSaleItemPrice(
            newData,
            { ...currentRowData, ...newData },
            this.model.SalesOrderTypeCode,
            this.model.BranchCode,
            this.model.CustomerCode,
            this.model.ExchangeRate,
            this.model.DateIn,
            this.model.RequiredByDate,
            false
          ).then((res) => {
            res.SalesUMFXPricePreviousValue = res.SalesUMFXPrice;
            this.localUpdate(currentRowData.ID, res);
            this.addToReview({ ...currentRowData, ...res });
          });
        }, 500);
      }
    },
    async onSalesUMFXPriceChanged(newData, value, currentRowData) {
      newData.SalesUMFXPrice = value;
      var SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        value,
        currentRowData.DiscPcnt
      );

      let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      let tempGp = calculateGrossProfitPcnt(
        currentRowData.SalesUMStandardCost,
        newsalesUMNetPrice
      );

      let globalGPVal = parseFloat(getFactorByCode(571).Factorc);

      if (this.priceChangeTimeId) clearTimeout(this.priceChangeTimeId);

      this.priceChangeTimeId = setTimeout(async () => {
        if (globalGPVal != 0 && tempGp < globalGPVal) {
          if (currentRowData.SalesUMQty != 0) {
            this.$store.dispatch("numericInputStore/lastEntry", {
              value: 0,
              remove: true,
            });
            let res = await alert(
              `Net Price is below the minimum GP of ${
                globalGPVal.roundNumber(2) + " %"
              }. Please enter a discount that meets the minimum GP % requirement.`,
              "Validation Error"
            );

            if (res) {
              var dataGrid = this.$refs["dx-data-grid-comp"].instance;
              // this.$nextTick(() => {
              //   dataGrid.saveEditData();
              // });

              setTimeout(() => {
                if (
                  this.focusedCellData &&
                  this.focusedCellData.cellInfo.column.dataField ==
                    "SalesUMFXPrice"
                )
                  this.$store.dispatch(
                    "numericInputStore/updateValue",
                    currentRowData.SalesUMFXPricePreviousValue
                  );

                newData.TriggerPriceUpdate = false;
                newData.SalesUMFXPrice =
                  currentRowData.SalesUMFXPricePreviousValue;
                // this.updateDataSource(newData, currentRowData, true);
                this.localUpdate(currentRowData.ID, newData);
                this.addToReview({ ...currentRowData, ...newData });

                setTimeout(() => {
                  var rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
                  var cell = dataGrid.getCellElement(
                    rowIndex,
                    "SalesUMFXPrice"
                  );
                  dataGrid.editCell(rowIndex, "SalesUMFXPrice");

                  this.$nextTick(() => {
                    dataGrid.focus(cell);
                  });
                }, 50);

                setTimeout(() => {
                  this.applyFocusClass();
                }, 100);
              }, 1);
            }
          }
        } else {
          newData.SalesUMFXPricePreviousValue = value;

          newData.SalesUMNetFXPrice = SalesUMNetFXPrice;

          // setBaseCurrencyPriceFromFXPrice
          newData.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
            newData.SalesUMFXPrice,
            this.model.ExchangeRate
          );

          newData.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
            currentRowData.SalesUMStandardPrice,
            newData.SalesUMPrice
          );

          newData.SalesUMNetPrice = newsalesUMNetPrice;

          // setStockPrices
          newData.StockUMQty = calculateStockUMQty(
            currentRowData.SalesUMQty,
            currentRowData.SalesUMConversion
          );

          // Stock
          newData.StockUMFXPrice = calculateStockUMFXPrice(
            newData.SalesUMFXPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMNetFXPrice = calculateStockUMNetFXPrice(
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMPrice = calculateStockUMPrice(
            newData.SalesUMPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMNetPrice = calculateStockUMNetPrice(
            newData.SalesUMNetPrice,
            currentRowData.SalesUMConversion
          );

          // setLineTotals
          // FX Totals
          newData.DiscFXLineTotal = calculateDiscFXLineTotal(
            newData.SalesUMFXPrice,
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMQty
          );
          newData.NetFXLineTotal = calculateNetFXLineTotal(
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMQty
          );
          newData.WetFXLineTotal = calculateWetFXLineTotal(
            newData.NetFXLineTotal,
            currentRowData.WetPcnt
          );

          newData.TaxableFXLineTotal = calculateTaxableFXLineTotal(
            newData.NetFXLineTotal,
            newData.WetFXLineTotal
          );
          newData.TaxFXLineTotal = calculateTaxFXLineTotal(
            newData.NetFXLineTotal,
            newData.WetFXLineTotal,
            currentRowData.SalesTaxPcnt
          );
          newData.FXLineTotal = calculateFXLineTotal(
            newData.TaxableFXLineTotal,
            newData.TaxFXLineTotal
          );

          // Totals
          newData.DiscLineTotal = calculateDiscLineTotal(
            newData.DiscFXLineTotal,
            this.model.ExchangeRate
          );
          newData.NetLineTotal = calculateNetLineTotal(
            newData.NetFXLineTotal,
            this.model.ExchangeRate
          );
          newData.WetLineTotal = calculateWetLineTotal(
            newData.WetFXLineTotal,
            this.model.ExchangeRate
          );
          newData.TaxableLineTotal = calculateTaxableLineTotal(
            newData.TaxableFXLineTotal,
            this.model.ExchangeRate
          );
          newData.TaxLineTotal = calculateTaxLineTotal(
            newData.TaxFXLineTotal,
            this.model.ExchangeRate
          );
          newData.LineTotal = calculateLineTotal(
            newData.FXLineTotal,
            this.model.ExchangeRate
          );

          this.localUpdate(currentRowData.ID, newData);
          if (currentRowData.SalesUMQty > 0) {
            this.addToReview({ ...currentRowData, ...newData });
          }
        }
      }, 1000);
    },
    async onDiscPcntChanged(newData, value, currentRowData) {
      newData.DiscPcnt = value;
      if (currentRowData.SalesUMQty > 0) {
        // newData.TiggerPriceLookUp = false;
        // newData.TriggerPriceUpdate = false;
        // newData.TriggerDiscountUpdate = true;

        var SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
          currentRowData.SalesUMFXPrice,
          value
        );

        let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
          SalesUMNetFXPrice,
          this.model.ExchangeRate
        );

        let tempGp = calculateGrossProfitPcnt(
          currentRowData.SalesUMStandardCost,
          newsalesUMNetPrice
        );

        let globalGPVal = parseFloat(getFactorByCode(571).Factorc);

        if (globalGPVal != 0 && (tempGp < globalGPVal || tempGp > 100)) {
          if (currentRowData.SalesUMQty != 0) {
            let res = await alert(
              `Net Price is below the minimum GP of ${
                globalGPVal.roundNumber(2) + " %"
              }. Please enter a discount that meets the minimum GP % requirement.`,
              "Validation Error"
            );

            if (res) {
              this.$store.dispatch(
                "numericInputStore/updateValue",
                currentRowData.DiscPcnt
              );

              this.$store.dispatch("numericInputStore/lastEntry", {
                value: 0,
                remove: true,
              });

              newData.DiscPcnt = currentRowData.DiscPcnt;
              // var dataGrid = this.$refs["dx-data-grid-comp"].instance;

              // this.$nextTick(() => {
              //   dataGrid.saveEditData();
              // });

              // setTimeout(() => {
              //   newData.TriggerDiscountUpdate = false;
              //   newData.DiscPcnt = currentRowData.DiscPcntPreviousValue;
              //   this.updateDataSource(newData, currentRowData, true);

              //   setTimeout(() => {
              //     var rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
              //     var cell = dataGrid.getCellElement(rowIndex, "DiscPcnt");
              //     dataGrid.editCell(rowIndex, "DiscPcnt");

              //     this.$nextTick(() => {
              //       dataGrid.focus(cell);
              //     });
              //   }, 50);

              //   setTimeout(() => {
              //     this.applyFocusClass();
              //   }, 100);
              // }, 100);
            }
          }

          this.localUpdate(currentRowData.ID, newData);
        } else {
          newData.TriggerDiscountUpdate = false;
          newData.DiscPcnt = value;
          newData.DiscPcntPreviousValue = value;
          newData.SalesUMNetFXPrice = SalesUMNetFXPrice;

          var obj = { ...currentRowData, ...newData };
          obj = SalesOrderState.setStockPrices(obj);
          obj = SalesOrderState.setLineTotals(obj, this.model);

          if (obj.SalesUMQty > 0) this.addToReview(obj);

          this.localUpdate(currentRowData.ID, obj);
        }
      }
    },
    localUpdate(id, data) {
      if (this.soDetailsCurrentView == "ProductList") {
        // this.productDataSourceItems.update(id, data).then(() => {
        //   this.productDataSourceItems.load();
        // })
        this.productDataSourceItems.push([
          { type: "update", data: data, key: id },
        ]);
        // .then(() => {
        //   this.productDataSourceItems.load();
        // });
        // this.changes = [
        //   {
        //     type: "update",
        //     data: data,
        //     key: id,
        //   },
        // ];
      } else if (this.soDetailsCurrentView == "CustomerList") {
        this.customerDataSourceItems.push([
          { type: "update", data: data, key: id },
        ]);
      } else {
        this.reviewDataList.push([{ type: "update", data: data, key: id }]);
      }
      // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      // this.$nextTick(() => {
      //   dataGrid.repaint();
      // });
    },
    qtyChangeWarning(data) {
      this.displayWarningSummary([
        {
          message: `The current line has already had a delivery processed and you may not reduce the order qty below ${data.SalesUMSuppliedQty}. The order qty has been reset.`,
        },
      ]);
    },
    onCellClick(e) {
      if (e) {
        // PriceLookUp on QTY change
        if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
          this.getAvailableLookups("TiggerPriceLookUp").forEach((element) => {
            this.updatePriceData(element, element);
          });
        }

        // Update Values on SalesUMFXPrice change
        if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
          this.getAvailableLookups("TriggerPriceUpdate").forEach((element) => {
            var newData = this.onPriceUpdateValidateGPToolPrcnt(
              element,
              element.SalesUMFXPrice,
              element
            );
            this.updateDataSource(newData, element);
          });
        }

        // Update Values on DiscPcnt change
        if (this.getAvailableLookups("TriggerDiscountUpdate").length > 0) {
          this.getAvailableLookups("TriggerDiscountUpdate").forEach(
            (element) => {
              this.onDiscountPrctUpdate(element, element.DiscPcnt, element);
            }
          );
        }
      }
    },
    setDiscountUpdate(newData, value, currentRowData) {
      var obj = { ...currentRowData, ...newData };
      this.discountTimeOut = setTimeout(() => {
        if (this.getCurrentDataObj(obj).TriggerDiscountUpdate)
          this.onDiscountPrctUpdate(newData, value, currentRowData);
      }, 2000);
    },
    setPriceUpdate(newData, value, currentRowData) {
      var obj = { ...currentRowData, ...newData };
      this.priceUpdateTimeOut = setTimeout(() => {
        if (this.getCurrentDataObj(obj).TriggerPriceUpdate)
          newData = this.onPriceUpdateValidateGPToolPrcnt(
            newData,
            value,
            currentRowData
          );
      }, 2000);
    },
    setUpdatePriceData(newData, obj) {
      this.timeOutID = setTimeout(() => {
        if (this.getCurrentDataObj(obj).TiggerPriceLookUp) {
          this.updatePriceData(newData, obj);
        }
      }, 2000);
    },
    updateDataSource(newData, currentRowData, refresh) {
      var res = undefined;
      if (currentRowData) res = { ...currentRowData, ...newData };
      else res = newData;

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      if (res.IsCopyLine) {
        var index = this.localCopyItems.findIndex((x) => x.ID == res.ID);
        if (index != -1) {
          this.localCopyItems.splice(index, 1);
          this.$nextTick(() => {
            this.localCopyItems.push(res);
            this.addToReview(res);
          });
        }
      } else if (
        this.soDetailsCurrentView == "CustomerList" ||
        res.Origin == "Customer"
      ) {
        this.customerDataSourceItems.update(res.ID, res).then((data) => {
          this.addToReview(data);
          if (refresh) {
            dataGrid.refresh(true);
          }
        });
      } else if (
        this.soDetailsCurrentView == "ProductList" ||
        res.Origin == "Product"
      ) {
        this.productDataSourceItems.update(res.ID, res).then((data) => {
          this.addToReview(data);
          if (refresh) {
            dataGrid.refresh(true);
          }
        });
      } else {
        this.reviewDataList.update(res.ID, res).then(() => {
          if (refresh) {
            dataGrid.refresh(true);
          }
        });
      }
    },
    getAvailableLookups(dataField) {
      if (this.localCopyItems.filter((i) => i[dataField]).length > 0) {
        return this.localCopyItems.filter((i) => i[dataField]);
      } else if (this.soDetailsCurrentView == "CustomerList") {
        return this.customerDataSourceItems._array.filter((i) => i[dataField]);
      } else if (this.soDetailsCurrentView == "ProductList") {
        return this.productDataSourceItems._array.filter((i) => i[dataField]);
      } else {
        return this.reviewDataList._array.filter((i) => i[dataField]);
      }
    },
    getCurrentDataObj(res) {
      if (res.IsCopyLine) {
        return this.localCopyItems.find((i) => i.ID == res.ID);
      } else if (
        this.soDetailsCurrentView == "CustomerList" ||
        res.Origin == "Customer"
      ) {
        return this.customerDataSourceItems._array.find((i) => i.ID == res.ID);
      } else if (
        this.soDetailsCurrentView == "ProductList" ||
        res.Origin == "Product"
      ) {
        return this.productDataSourceItems._array.find((i) => i.ID == res.ID);
      } else {
        return this.reviewDataList._array.find((i) => i.ID == res.ID);
      }
    },
    // Load Products
    async loadProductItems(totalItemsCount, skip) {
      var filter = `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`;

      if (this.model.BranchCode) {
        filter = filter + ` and BranchCode eq '${this.model.BranchCode}'`;
      }

      if (!totalItemsCount || skip < totalItemsCount)
        ProductService.getCustomData({
          url: "api/ProductFilterGroupSaleItemCompanyBranch",
          count: true,
          skip: skip,
          top: 1000,
          filter: filter,
        }).then((res) => {
          if (!totalItemsCount) totalItemsCount = res.data["@odata.count"];
          res.data.value.forEach((element) => {
            element.OriginItemCode = element.ItemCode;
            element.HasPromotion = false;

            element.Origin = "Product";
            element.SalesUMQty = 0;
            element.SalesUMFXPrice = 0;
            element.TaxableFXLineTotal = 0;
            element.TaxFXLineTotal = 0;
            element.FXLineTotal = 0;
            element = { ...soDetailsBaseRecord, ...element };

            element.ID = element.ItemCode;

            // element = this.productListPostProcess([element])[0];

            this.productDataSourceItems.insert(element);

            var items = this.reviewDataList._array.filter((x) => {
              return x.OriginItemCode == element.OriginItemCode;
            });

            items.forEach((i) => {
              this.reviewDataList.update(i.ID, {
                Available: element.Available,
              });
            });

            var copyItems = this.productDataSourceItems._array.filter(
              (c) => c.OriginItemCode == element.OriginItemCode
            );
            copyItems.forEach((ci) => {
              this.productDataSourceItems.update(ci.ID, {
                Available: element.Available,
              });
            });
          });

          this.setItemPromotions(res.data.value);

          if (this.$refs["dx-data-grid-comp"]) {
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;
            if (dataGrid) dataGrid.refresh();
          }

          if (totalItemsCount > 0)
            this.loadProductItems(totalItemsCount, skip + 1000);
        });
      else {
        return;
      }
    },
    productListPostProcess(data) {
      var items = [];
      data.forEach((element) => {
        var i = this.reviewDataList._array.findIndex((x) => {
          if (x.LineNo > 0) {
            return x.ID == element.ID + "-" + x.LineNo;
          } else return x.ID == element.ID;
        });

        var item = undefined;
        var ums = [];
        if (i == -1) item = element;
        else {
          item = this.reviewDataList._array[i];
          item.Available = element.Available;
        }

        this.salesUMsLocalData.forEach((um) => {
          if (um.ItemCode == item.ItemCode) ums.push(um);
        });

        item.SLUMLength = ums.length;
        item.SalesUMs = ums;

        items.push(item);

        this.localCopyItems.forEach((copy) => {
          if (
            copy.OriginItemCode == item.ItemCode ||
            copy.OriginItemCode == item.OriginItemCode
          ) {
            var c_i = this.reviewDataList._array.findIndex(
              (x) => x.ID == copy.ID
            );

            if (c_i != -1) {
              items.push(this.reviewDataList._array[c_i]);
            } else {
              items.push(copy);
            }
          }
        });
      });

      return items;
    },
    loadCustomerItems(totalItemsCount, skip) {
      var filter = `ItemType eq 'S' and IsDefault eq 'Y' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`;

      if (this.model.BranchCode) {
        filter = filter + ` and BranchCode eq '${this.model.BranchCode}'`;
      }

      if (!totalItemsCount || skip < totalItemsCount)
        ProductService.getCustomData({
          url: "api/CustomerSaleItemCompanyBranch",
          count: true,
          skip: skip,
          top: 1000,
          filter: filter,
        }).then((res) => {
          if (!totalItemsCount) totalItemsCount = res.data["@odata.count"];
          res.data.value.forEach((element) => {
            element.OriginItemCode = element.ItemCode;
            element.HasPromotion = false;
            element.Origin = "Customer";
            element.SalesUMQty = 0;
            element.SalesUMFXPrice = 0;
            element.TaxableFXLineTotal = 0;
            element.TaxFXLineTotal = 0;
            element.FXLineTotal = 0;
            element = { ...soDetailsBaseRecord, ...element };

            element.ID = element.ItemCode;

            // element = this.productListPostProcess([element])[0];

            this.customerDataSourceItems.insert(element);

            // var items = this.reviewDataList._array.filter((x) => { return x.OriginItemCode == element.OriginItemCode && !x.IsCopyLine });

            // items.forEach(i => {
            //   this.reviewDataList.update(i.ID, { Available: element.Available });
            // });

            var copyItems = this.customerDataSourceItems._array.filter(
              (c) => c.OriginItemCode == element.OriginItemCode
            );
            copyItems.forEach((ci) => {
              this.customerDataSourceItems.update(ci.ID, {
                Available: element.Available,
              });
            });
          });

          this.setItemPromotions(res.data.value);
          if (totalItemsCount > 0)
            this.loadCustomerItems(totalItemsCount, skip + 1000);
        });
      else {
        return;
      }
    },
    closeDeliveryAddressPopup() {
      this.editDeliveryAddressVisible = false;
    },
    showDeliveryAddress() {
      var item = { ...this.model };
      this.addressData = {
        DeliveryAddressCompanyName: item.DeliveryAddressCompanyName,
        DeliveryAddressCountry: item.DeliveryAddressCountry,
        DeliveryAddressPostcode: item.DeliveryAddressPostcode,
        DeliveryAddressState: item.DeliveryAddressState,
        DeliveryAddressStreetLine1: item.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: item.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: item.DeliveryAddressSuburb,
      };
      this.editDeliveryAddressVisible = true;
    },
    updateDeliveryAddress() {
      this.editDeliveryAddressVisible = false;

      this.model.DeliveryAddressCompanyName =
        this.addressData.DeliveryAddressCompanyName;
      this.model.DeliveryAddressStreetLine1 =
        this.addressData.DeliveryAddressStreetLine1;
      this.model.DeliveryAddressStreetLine2 =
        this.addressData.DeliveryAddressStreetLine2;
      this.model.DeliveryAddressSuburb = this.addressData.DeliveryAddressSuburb;
      this.model.DeliveryAddressState = this.addressData.DeliveryAddressState;
      this.model.DeliveryAddressPostcode =
        this.addressData.DeliveryAddressPostcode;
      this.model.DeliveryAddressCountry =
        this.addressData.DeliveryAddressCountry;
    },
    headerFormValueChanged(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
      // else {
      // }
    },
    setPopupVisible(e, type, params) {
      e.component.blur();
      switch (type) {
        case "Customer":
          this.popupConfig = {
            title: "Customer Search",
            dataGrid: {
              toolbar: {
                salesrep: true,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onCustomerRowClick,
              },
              dataSource: CustomerService.dataSourceConfig("api/Customer", {
                select: [
                  "Code",
                  "Name",
                  "SalesRepresentativeCode",
                  "CurrencyCode",
                  "StopCredit",
                  "TermCalculation",
                ],
                sort: [{ selector: "Name", asc: true }],
                filter: this.selectPopupModel.filterBySalesRep
                  ? [
                      [
                        "SalesRepresentativeCode",
                        "=",
                        this.selectPopupModel.filterBySalesRep,
                      ],
                      "and",
                      ["Inactive", "=", "N"],
                    ]
                  : ["Inactive", "=", "N"],
                key: "Code",
              }),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Name}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "Name",
                  dataField: "Name",
                  visible: false,
                },
              ],
            },
          };

          this.popupVisible = true;
          break;
        case "Branch":
          this.popupConfig = {
            title: "Branch Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onBranchRowClick,
                keyExpr: "Code",
              },
              dataSource: BranchService.dataSourceConfig("api/Branch", {
                sort: [{ selector: "Description", asc: true }],
                select: ["Description", "Code"],
                filter: ["Inactive", "=", "N"],
                key: "Code",
              }),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Description}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "Description",
                  dataField: "Description",
                  visible: false,
                },
              ],
            },
          };
          this.popupVisible = true;
          break;
        case "Division":
          this.popupConfig = {
            title: "Division Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onDivisionRowClick,
              },
              dataSource: DivisionService.dataSourceConfig("api/Division", {
                sort: [{ selector: "Description", asc: true }],
                select: ["Description", "Code"],
                filter: ["Inactive", "=", "N"],
                key: "Code",
              }),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Description}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "Description",
                  dataField: "Description",
                  visible: false,
                },
              ],
            },
          };
          this.popupVisible = true;
          break;
        case "SalesOrderType":
          this.popupConfig = {
            title: "SO Type Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onSalesOrderTypeRowClick,
              },
              dataSource: SalesOrderTypeService.dataSourceConfig(
                "api/SalesOrderType",
                {
                  select: ["Code", "Description"],
                  filter: ["Inactive", "=", "N"],
                  sort: [{ selector: "Description", asc: true }],
                  key: "Code",
                }
              ),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Description}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "Description",
                  dataField: "Description",
                  visible: false,
                },
              ],
            },
          };
          this.popupVisible = true;
          break;
        case "SalesRep":
          this.popupConfig = {
            title: "Sales Rep Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onSalesRepRowClick,
              },
              dataSource: SalesRepresentativeService.dataSourceConfig(
                "api/SalesRepresentative",
                {
                  select: ["Code", "FirstName", "Surname"],
                  filter: ["Inactive", "=", "N"],
                  sort: [{ selector: "FirstName", asc: true }],
                  key: "Code",
                }
              ),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.FirstName} ${info.data.Surname}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "FirstName",
                  dataField: "FirstName",
                  visible: false,
                },
                {
                  caption: "Surname",
                  dataField: "Surname",
                  visible: false,
                },
              ],
            },
          };
          this.popupVisible = true;
          break;
        case "DeliverTo":
          this.popupConfig = {
            title: "Deliver To Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onDeliverToRowClick,
              },
              dataSource: CustomerDeliveryAddressService.dataSourceConfig(
                "api/CustomerDeliveryAddress",
                {
                  select: [
                    "CompanyName",
                    "PhysicalAddressStreetLine1",
                    "PhysicalAddressStreetLine2",
                    "PhysicalAddressSuburb",
                    "PhysicalAddressState",
                    "PhysicalAddressPostcode",
                    "PhysicalAddressCountry",
                    "RecordId",
                    "LineNo",
                  ],
                  key: "RecordId",
                  filter: [
                    ["Inactive", "=", "N"],
                    "and",
                    ["CustomerCode", "=", this.model.CustomerCode],
                  ],
                }
              ),
              columns: [
                {
                  caption: "Company Name",
                  dataField: "CompanyName",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.CompanyName}
                        </span>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressStreetLine1} </div>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressStreetLine2} </div>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressSuburb} </div>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressState} </div>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressPostcode} </div>
                        <div class="record-secondary gc-grid-code"> ${info.data.PhysicalAddressCountry} </div>
                      </div>`);
                  },
                },
                {
                  caption: "PhysicalAddressStreetLine1",
                  dataField: "PhysicalAddressStreetLine1",
                  visible: false,
                },
                {
                  caption: "AddressStreet Line 2",
                  dataField: "PhysicalAddressStreetLine2",
                  visible: false,
                },
                {
                  caption: "PhysicalAddressSuburb",
                  dataField: "PhysicalAddressSuburb",
                  visible: false,
                },
                {
                  caption: "PhysicalAddressState",
                  dataField: "PhysicalAddressState",
                  visible: false,
                },
                {
                  caption: "PhysicalAddressPostcode",
                  dataField: "PhysicalAddressPostcode",
                  visible: false,
                },
                {
                  caption: "PhysicalAddressCountry",
                  dataField: "PhysicalAddressCountry",
                  visible: false,
                },
              ],
            },
          };
          this.popupVisible = true;

          break;
        case "ProductCategory1":
          this.popupConfig = {
            title: "Product Category 1 Filter",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: true,
                // onRowClick: this.onCustomerRowClick,
                onOkClick: this.onProductCategory1Changed,
                selectedValues: this.selectedProductCategory1,
              },
              dataSource: ProductCategory1Service.dataSourceConfig(
                "api/ProductCategory1",
                {
                  select: ["Code", "Description"],
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }
              ),
              columns: [
                {
                  caption: "Code",
                  dataField: "Code",
                  cellTemplate: (data, info) => {
                    return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Description}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.Code}
                        </span>
                      </div>`);
                  },
                },
                {
                  caption: "Description",
                  dataField: "Description",
                  visible: false,
                },
              ],
            },
          };

          this.popupVisible = true;
          break;
        case "SalesUM":
          this.selectedRowData = params.cellInfo;
          this.popupConfig = {
            title: "SalesUM Search",
            dataGrid: {
              toolbar: {
                salesrep: false,
              },
              options: {
                multipleSelect: false,
                onRowClick: this.onSalesUMRowClick,
                keyExpr: "SalesUM",
              },
              dataSource: SalesOrderTypeService.dataSourceConfig(
                "api/SaleItemCompanyBranch",
                {
                  select: ["SalesUM", "ItemType", "ItemCode", "BranchCode"],
                  filter: [
                    ["ItemType", "=", "S"],
                    "and",
                    ["BranchCode", "=", this.model.BranchCode],
                    "and",
                    ["AvailableForSale", "=", "Y"],
                    "and",
                    ["ItemCode", "=", params.ItemCode],
                  ],
                  sort: [{ selector: "SalesUM", asc: true }],
                  key: "SalesUM",
                }
              ),
              columns: [
                {
                  caption: "SalesUM",
                  dataField: "SalesUM",
                },
                {
                  caption: "ItemCode",
                  dataField: "ItemCode",
                  visible: false,
                },
              ],
            },
          };

          this.popupVisible = true;

          break;
        default:
          break;
      }
    },
    onSalesUMInitialized(e) {
      if (e.component.option().readOnly) {
        e.element.parentElement.parentElement.classList.add("cell-disabled");
      }
    },
    onSalesUMFocusIn(e, cellInfo) {
      if (!e.component.option().readOnly)
        this.setPopupVisible(e, "SalesUM", {
          ItemCode: cellInfo.data.OriginItemCode,
          cellInfo: cellInfo,
        });
      else e.component.blur();

      // PriceLookUp on QTY change
      if (this.getAvailableLookups("TiggerPriceLookUp").length > 0) {
        this.getAvailableLookups("TiggerPriceLookUp").forEach((element) => {
          this.updatePriceData(element, element);
        });
      }

      // Update Values on SalesUMFXPrice change
      if (this.getAvailableLookups("TriggerPriceUpdate").length > 0) {
        this.getAvailableLookups("TriggerPriceUpdate").forEach((element) => {
          var newData = this.onPriceUpdateValidateGPToolPrcnt(
            element,
            element.SalesUMFXPrice,
            element
          );
          this.updateDataSource(newData, element);
        });
      }

      // Update Values on DiscPcnt change
      if (this.getAvailableLookups("TriggerDiscountUpdate").length > 0) {
        this.getAvailableLookups("TriggerDiscountUpdate").forEach((element) => {
          this.onDiscountPrctUpdate(element, element.DiscPcnt, element);
        });
      }
    },
    popupHiddenCallBack(show) {
      this.popupVisible = show;
      this.gpToolPopupVisible = false;
      this.productDetailsPopupVisible = false;
    },
    async checkHeaderFormValidation() {
      let validationResult = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      let headerform = await validationEngine.validateGroup("gc-header-form");
      let commentsform = await validationEngine.validateGroup(
        "gc-header-comments"
      );
      if (
        !validationResult.isValid ||
        !headerform.isValid ||
        !commentsform.isValid
      )
        this.displayValidationSummary(
          validationResult.brokenRules
            .concat(headerform.brokenRules)
            .concat(commentsform.brokenRules)
        );
      else {
        if (this.reviewDataList._array.length == 0) {
          this.displayValidationErrors([
            "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again.",
          ]);
          return;
        } else if (this.model.NextStatus == "X") {
          let confirmLeaving = await this.$confirm(
            "Do you really wish to cancel sales order?",
            "Cancel sales order"
          );

          if (confirmLeaving) {
            this.$logger.trackEventButtonClick("Cancel Sales Order");
            this.cancelSalesOrder();
          }
        } else {
          let payload = this.getSavePayload();
          var confirmSave = true;

          const zeroDollarItems = this.getSalesOrderDetailPayload().filter(
            (i) => i.SalesUMFXPrice == 0
          );
          if (zeroDollarItems.length > 0) {
            confirmSave = await this.$confirm(
              "There are entries with prices set at $0.00. Do you wish to continue?",
              "Save sales order"
            );
          }

          if (confirmSave) {
            this.showLoading(true);
            await SalesOrderV3Service.saveSalesOrder(payload, payload.Code)
              .then((res) => {
                this.showLoading(false);

                if (this.baseView.mode == "create") {
                  this.model.Code = res.data.Code;
                }

                this.$notify(
                  `Sales Order ${this.model.Code} Successfully Saved`,
                  "success"
                );

                this.setIgnoreRouteChangeConfirmation();
                this.$router.push({
                  path: `/sales-order`,
                });
              })
              .catch((error) => {
                this.showLoading(false);

                this.displayServerError(error, "Save Sales Order Failed");
              });
          }
        }
      }
    },
    getSavePayload() {
      var ExTaxTotal = 0;
      var TaxTotal = 0;
      var Total = 0;
      this.reviewDataList._array.forEach((element) => {
        if (element.ItemCode && element.SalesUMQty) {
          ExTaxTotal = ExTaxTotal + element.TaxableFXLineTotal;
          TaxTotal = TaxTotal + element.TaxFXLineTotal;
          Total = Total + element.FXLineTotal;
        }
      });
      let payload = {
        BranchCode: this.model.BranchCode,
        Code: this.baseView.mode != "create" ? parseInt(this.baseView.id) : 0,
        CompanyCode: this.model.CompanyCode,
        ConsignmentNo: this.model.ConsignmentNo,
        CurrencyCode: this.model.CurrencyCode,
        CustomerCode: this.model.CustomerCode,
        CustomerDeliveryAddressLineNo:
          this.model.CustomerDeliveryAddressLineNo.toString(),
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.NextStatus,
        DivisionCode: this.model.DivisionCode,
        ExchangeRate: this.model.ExchangeRate,
        ExTaxTotal: parseFloat(ExTaxTotal.toFixed(2)),
        ItemCount: this.getSalesOrderDetailPayload().length,
        OrderNo: this.model.OrderNo,
        RequiredByDate: new Date(this.model.RequiredByDate).toSaveDate(),
        SalesOrderTypeCode: this.model.SalesOrderTypeCode,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode,
        ShipDate: new Date(this.model.ShipDate).toSaveDate(),
        // Status: "A",
        TaxTotal: parseFloat(TaxTotal.toFixed(2)),
        Total: parseFloat(Total.toFixed(2)),
        UserComment1: this.model.UserComment1,
        UserComment2: this.model.UserComment2,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment20: this.model.UserComment20,

        SalesOrderDetails: this.getSalesOrderDetailPayload(),
        SalesOrderNotes: [],
      };

      if (this.model.Notes && this.model.Notes.length > 0) {
        let notes = this.model.Notes.map((note) => {
          let n = {
            LineNo: note.LineNo ? note.LineNo : 0,
            Note: note.Note,
          };
          return n;
        });
        payload.SalesOrderNotes = notes;
      }

      if (this.baseView.mode != "create") {
        payload.DateChanged = this.model.DateChanged;
      }
      return payload;
    },
    getSalesOrderDetailPayload() {
      let details = [];

      this.reviewDataList._array.forEach((data) => {
        let detailObj = {
          SalesOrderCode: data.SalesOrderCode ? data.SalesOrderCode : 0,
          LineNo: data.LineNo ? data.LineNo : 0,
          ItemCode: data.OriginItemCode,
          SalesUM: data.SalesUM,
          SalesUMQty: data.SalesUMQty,
          DiscPcnt: data.DiscPcnt,
          SalesUMFXPrice: data.SalesUMFXPrice,
          Comment: data.Comment,
          IsCommentVisible: data.IsCommentVisible,
          RecordId: "00000000-0000-0000-0000-000000000000",
        };

        if (data.OriginItemCode && data.SalesUMQty) details.push(detailObj);
      });

      return details;
    },
    async cancelSalesOrder() {
      this.showLoading(true);
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.showLoading(false);
          this.displayServerError(error, "Cancel sales order Failed");
        });
    },
    onTabClick(data) {
      this.selectedIndex = data.itemIndex;
      this.forceRefresh = true;
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    clearProductList() {
      var items = this.productDataSourceItems._array.filter(
        (p) => p.IsCopyLine
      );
      this.productDataSourceItems.clear();
      items.forEach((element) => {
        this.productDataSourceItems.insert(element);
      });
    },
    clearCustomerList() {
      var items = this.customerDataSourceItems._array.filter(
        (p) => p.IsCopyLine
      );
      this.customerDataSourceItems.clear();
      items.forEach((element) => {
        this.customerDataSourceItems.insert(element);
      });
    },
    onCustomerValueChanged(e) {
      if (e.value == "") this.model.CustomStatus = undefined;
      this.triggerPriceChange(e);

      this.productDataSourceItems.clear();
      this.customerDataSourceItems.clear();
      this.loadProductItems(undefined, 0);
      this.loadCustomerItems(undefined, 0);
    },
    async onCustomerRowClick(e) {
      this.popupHiddenCallBack(false);

      let customerRecord = e.data;

      if (
        this.allowPriceChangeTriggerConfirmation &&
        this.reviewDataList._array.length > 0
      ) {
        let confirmPriceChange = await this.$confirm(
          `Would you like to recalculate the sell price of all items based upon this new Customer?`,
          "Price Change"
        );

        if (confirmPriceChange) {
          if (customerRecord.StopCredit == "Y")
            this.model.CustomStatus = "Credit Hold";
          else if (customerRecord.TermCalculation == "CBD") {
            this.model.CustomStatus = "Cash Before Despatch";
          } else this.model.CustomStatus = undefined;

          if (!customerRecord) {
            return;
          }
          this.model.CustomerCode = customerRecord.Code;
          this.model.CurrencyCode = customerRecord.CurrencyCode;
          this.model.CustomerName = customerRecord.Name;

          this.setFooterItems([]);

          this.selectSalesRepOnCustomerChange(customerRecord);

          this.setExchangeRateProperties();
          await this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);
        }
      } else {
        if (customerRecord.StopCredit == "Y")
          this.model.CustomStatus = "Credit Hold";
        else if (customerRecord.TermCalculation == "CBD") {
          this.model.CustomStatus = "Cash Before Despatch";
        } else this.model.CustomStatus = undefined;

        if (!customerRecord) {
          return;
        }
        this.model.CustomerCode = customerRecord.Code;
        this.model.CurrencyCode = customerRecord.CurrencyCode;
        this.model.CustomerName = customerRecord.Name;

        this.selectSalesRepOnCustomerChange(customerRecord);

        this.setFooterItems([]);

        this.setExchangeRateProperties();
        await this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);
      }
    },
    selectSalesRepOnCustomerChange(customerRecord) {
      if (!this.userDefaultSalesRep) {
        if (customerRecord.SalesRepresentativeCode) {
          this.model.SalesRepresentativeCode =
            customerRecord.SalesRepresentativeCode;
        } else {
          if (getFactorByCode(95).Factorc) {
            this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
          }
        }

        if (this.model.SalesRepresentativeCode) {
          this.getSalesRepName();
        }
      }
    },
    async onBranchRowClick(e) {
      this.popupHiddenCallBack(false);
      if (
        this.allowPriceChangeTriggerConfirmation &&
        this.reviewDataList._array.length > 0
      ) {
        let confirmPriceChange = await this.$confirm(
          `Would you like to recalculate the sell price of all items based upon this new Branch?`,
          "Price Change"
        );

        if (confirmPriceChange) {
          this.model.BranchCode = e.data.Code;
          this.model.BranchDescription = e.data.Description;
          this.clearProductList();
          this.clearCustomerList();
          this.loadProductItems(undefined, 0);
          this.loadCustomerItems(undefined, 0);
        }
      } else {
        this.model.BranchCode = e.data.Code;
        this.model.BranchDescription = e.data.Description;
        this.clearProductList();
        this.clearCustomerList();
        this.loadProductItems(undefined, 0);
        this.loadCustomerItems(undefined, 0);
      }
    },
    async onDivisionRowClick(e) {
      this.popupHiddenCallBack(false);
      if (
        this.allowPriceChangeTriggerConfirmation &&
        this.reviewDataList._array.length > 0
      ) {
        let confirmPriceChange = await this.$confirm(
          `Would you like to recalculate the sell price of all items based upon this new Division?`,
          "Price Change"
        );

        if (confirmPriceChange) {
          this.model.DivisionCode = e.data.Code;
          this.model.DivisionDescription = e.data.Description;
        }
      } else {
        this.model.DivisionCode = e.data.Code;
        this.model.DivisionDescription = e.data.Description;
      }
    },
    async onSalesOrderTypeRowClick(e) {
      this.popupHiddenCallBack(false);
      if (
        this.allowPriceChangeTriggerConfirmation &&
        this.reviewDataList._array.length > 0
      ) {
        let confirmPriceChange = await this.$confirm(
          `Would you like to recalculate the sell price of all items based upon this new Sales Order Type?`,
          "Price Change"
        );

        if (confirmPriceChange) {
          this.model.SalesOrderTypeCode = e.data.Code;
          this.model.SalesOrderTypeDescription = e.data.Description;
          this.setOrderComments(this.model.SalesOrderTypeCode);
        }
      } else {
        this.model.SalesOrderTypeCode = e.data.Code;
        this.model.SalesOrderTypeDescription = e.data.Description;
        this.setOrderComments(this.model.SalesOrderTypeCode);
      }
    },
    onSalesRepRowClick(e) {
      this.popupHiddenCallBack(false);
      this.model.SalesRepresentativeCode = e.data.Code;
      this.model.SalesRepresentativeFullName =
        e.data.FirstName + " " + e.data.Surname;
    },
    onDeliverToRowClick(e) {
      this.popupHiddenCallBack(false);
      var deliveryAddressLine1Record = e.data;

      this.model.DeliveryAddressCompanyName =
        deliveryAddressLine1Record.CompanyName;
      this.model.DeliveryAddressCountry =
        deliveryAddressLine1Record.PhysicalAddressCountry;
      this.model.DeliveryAddressPostcode =
        deliveryAddressLine1Record.PhysicalAddressPostcode;
      this.model.DeliveryAddressState =
        deliveryAddressLine1Record.PhysicalAddressState;
      this.model.DeliveryAddressStreetLine1 =
        deliveryAddressLine1Record.PhysicalAddressStreetLine1;
      this.model.DeliveryAddressStreetLine2 =
        deliveryAddressLine1Record.PhysicalAddressStreetLine2;
      this.model.DeliveryAddressSuburb =
        deliveryAddressLine1Record.PhysicalAddressSuburb;
      this.model.CustomerDeliveryAddressLineNo =
        deliveryAddressLine1Record.LineNo;
    },
    onProductCategory1Changed(e) {
      this.popupHiddenCallBack(false);

      this.selectedProductCategory1 = e;
    },
    async initialized() {
      if (this.baseView.mode == "create") {
        await this.$store.dispatch(
          "screenFactors/getFactors",
          [616, 549, 550, 95, 87, 565, 368, 18, 65, 505, 66, 571]
        );

        let factor87DefaultSalesOrderTypeCode = getFactorByCode(87);
        this.model.SalesOrderTypeCode =
          factor87DefaultSalesOrderTypeCode.Factorc;

        await SalesOrderTypeService.getByCode(
          this.model.SalesOrderTypeCode
        ).then((res) => {
          if (res.data.value.length > 0)
            this.model.SalesOrderTypeDescription =
              res.data.value[0].Description;
        });

        await this.setOrderComments(this.model.SalesOrderTypeCode);

        await this.setDefaultSalesRep();

        this.factor368ExchangeRateFieldEditable = getFactorByCode(368);

        //  Populate defaults in the Create Mode
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        this.model.CompanyCode = getFactorByCode(18).Factorc;
        this.model.BranchCode = getFactorByCode(65).Factorc;
        this.model.DivisionCode = getFactorByCode(66).Factorc;

        let response = undefined;
        if (
          !this.model.CompanyCode ||
          !this.model.BranchCode ||
          !this.model.DivisionCode
        ) {
          response = await DefaultCompanyBranchDivisionService.getDefault();

          if (response.data.value.length > 0) {
            this.model.CompanyCode = response.data.value[0].CompanyCode;
            this.model.BranchCode = response.data.value[0].BranchCode;
            this.model.DivisionCode = response.data.value[0].DivisionCode;
          }
        }

        await BranchService.getByCode(this.model.BranchCode).then((res) => {
          if (res.data.value.length > 0)
            this.model.BranchDescription = res.data.value[0].Description;
        });
        await DivisionService.getByCode(this.model.DivisionCode).then((res) => {
          if (res.data.value.length > 0)
            this.model.DivisionDescription = res.data.value[0].Description;
        });

        this.getSalesUMs(this.model.BranchCode);

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            if (res.data.value.length > 0) {
              this.model.CurrencyCode = res.data.value[0].CurrencyCode;
              this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
            }
          }
        );

        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;

        let factor549DefaultRequiredBy = getFactorByCode(549);

        if (factor549DefaultRequiredBy.Factorc == "Y") {
          let factor550RequiredByLeadDays = getFactorByCode(550);
          let requiredByLeadDays = parseInt(
            factor550RequiredByLeadDays.Factorc
          );
          let requiredByDate = new Date();
          requiredByDate.setDate(requiredByDate.getDate() + requiredByLeadDays);

          this.model.RequiredByDate = requiredByDate;

          let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
          if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In") {
            this.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
          } else {
            this.model.FilterDate = this.model.DateIn.toYYYYMMDD();
          }

          let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

          if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
            this.model.ShipDate = this.model.RequiredByDate;
          } else {
            this.model.ShipDate = new Date();
          }
        }

        this.setFooterItems([]);

        this.loaded = true;
        this.showLoading(false);
      } else {
        this.soDetailsCurrentView = "Review";
        await this.$store.dispatch("screenFactors/getFactors", [505, 616, 571]);

        await SalesOrderService.getByCode(this.baseView.id)
          .then((res) => {
            if (res.data.value.length > 0) {
              if (res.data.value[0].Customer.StopCredit == "Y")
                res.data.value[0].CustomStatus = "Credit Hold";
              else if (res.data.value[0].Customer.TermCalculation == "CBD") {
                res.data.value[0].CustomStatus = "Cash Before Despatch";
              } else res.data.value[0].CustomStatus = undefined;

              res.data.value[0].LineItemCode = undefined;

              res.data.value[0].SalesOrder = res.data.value[0].Code;
              res.data.value[0].CustomerName = res.data.value[0].Customer.Name;

              // this.model.CustomerDeliveryAddressLineNo =
              //   this.model.CustomerDeliveryAddressLineNo.split(" ")[0];

              res.data.value[0].SalesRepresentativeFullName =
                res.data.value[0].SalesRepresentative.FirstName +
                " " +
                res.data.value[0].SalesRepresentative.Surname;

              res.data.value[0].BranchDescription =
                res.data.value[0].Branch.Description;
              res.data.value[0].DivisionDescription =
                res.data.value[0].Division.Description;
              res.data.value[0].SalesOrderTypeDescription =
                res.data.value[0].SalesOrderType.Description;
              this.model = res.data.value[0];
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        if (this.baseView.mode == "edit") {
          await this.getSalesUMs(this.model.BranchCode);
          this.productDataSourceItems.clear();
          this.customerDataSourceItems.clear();
          this.loadProductItems(undefined, 0);
          this.loadCustomerItems(undefined, 0);
        }

        if (this.model.Status == "D" && this.baseView.mode !== "edit") {
          // force push screen to edit mode when the Sales Order is in Draft mode
          this.$router
            .push({
              path: `/t-sales-order/edit/${this.model.Code}/header`,
            })
            .then(() => {
              this.initialized();
            });
        } else {
          if (getFactorByCode(616).Factorc != "Date In") {
            this.model.FilterDate = new Date(
              this.model.RequiredByDate
            ).toYYYYMMDD();
          } else {
            this.model.FilterDate = new Date(this.model.DateIn).toYYYYMMDD();
          }
          await this.setOrderComments(this.model.SalesOrderTypeCode);

          let record = await SalesOrderV3Service.getSalesOrderDetailsByCode(
            this.baseView.id
          );
          if (record && record.data.value.length > 0) {
            var data = record.data.value;
            await data.forEach(async (element) => {
              var ums = [];
              element.ItemDescription = element.Description1;
              element.OriginItemCode = element.ItemCode;
              element.ProductCode = element.ItemCode;
              element.ProductDescription = element.Description1;
              element.ItemCode = element.ItemCode + "-" + element.LineNo;
              element.ID = element.ItemCode;
              // element.ID = index;
              // element.validCode = element.ItemCode;

              this.salesUMsLocalData.forEach((um) => {
                if (um.ItemCode == element.OriginItemCode) ums.push(um);
              });

              element.SLUMLength = ums.length;
              element.SalesUMs = ums;

              this.reviewDataList.insert(element);

              var items = this.reviewDataList._array.filter(
                (x) => x.ProductCode == element.ProductCode
              );
              if (items.length > 1) {
                element.IsCopyLine = true;
                // this.localCopyItems.push(element);
                this.reviewDataList.update(element.ID, { IsCopyLine: true });
              }
            });
          }

          this.setFooterItems(this.reviewDataList._array);
          this.setItemPromotions(this.reviewDataList._array);

          this.loaded = true;
          this.showLoading(false);
        }
      }
    },
    async editSOCallBack() {
      await this.getSalesUMs(this.model.BranchCode);

      this.reviewDataList._array.forEach((element) => {
        var ums = [];
        this.salesUMsLocalData.forEach((um) => {
          if (um.ItemCode == element.ItemCode) ums.push(um);
        });

        element.SLUMLength = ums.length;
        element.SalesUMs = ums;
      });

      this.productDataSourceItems.clear();
      this.customerDataSourceItems.clear();
      this.loadProductItems(undefined, 0);
      this.loadCustomerItems(undefined, 0);
    },

    async setDefaultSalesRep() {
      // var featureItems = FeatureStorage.getItems();
      // if (featureItems[0].ApplicationUserTypeCode == "Sales") {
      await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
        (res) => {
          if (res.data.value.length > 0)
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          this.userDefaultSalesRep = res.data.value[0].SalesRepresentativeCode;
        }
      );
      // }

      if (!this.model.SalesRepresentativeCode) {
        if (getFactorByCode(95).Factorc) {
          this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
        }
        // else {
        //   await CustomerService.getByCode(this.baseView.id)
        //     .then((res) => {
        //       if (res.data.value.length > 0)
        //         this.model.SalesRepresentativeCode =
        //           res.data.value[0].SalesRepresentativeCode;
        //     })
        //     .catch((err) => {
        //       if (err) {
        //         this.model.SalesRepresentativeCode = undefined;
        //       }
        //     });
        // }
      }

      if (this.model.SalesRepresentativeCode != "") {
        await this.getSalesRepName();
        this.selectPopupModel.filterBySalesRep =
          this.model.SalesRepresentativeCode;
      }
    },
    async getSalesRepName() {
      await SalesRepresentativeService.getByCode(
        this.model.SalesRepresentativeCode
      ).then((res) => {
        if (res && res.data && res.data.value && res.data.value.length > 0)
          this.model.SalesRepresentativeFullName =
            res.data.value[0].FirstName + " " + res.data.value[0].Surname;
      });

      if (this.model.SalesRepresentativeCode != "") {
        this.selectPopupModel.filterBySalesRep =
          this.model.SalesRepresentativeCode;
      }
    },
    async getSalesUMs(branchCode) {
      await SalesOrderV3Service.getSaleItemCompanyBranchProduct(
        branchCode
      ).then((res) => {
        this.salesUMsLocalData = res.data.value;
      });
    },

    updatePriceData(newData, rowData) {
      if (this.timeOutID) clearTimeout(this.timeOutID);

      this.timeOutID = setTimeout(() => {
        newData.TiggerPriceLookUp = rowData.TiggerPriceLookUp = false;
        if (
          rowData.SalesUMSuppliedQty > 0 &&
          newData.SalesUMQty < rowData.SalesUMSuppliedQty
        ) {
          newData.SalesUMQty = rowData.SalesUMQtyPreviousValue;
          this.qtyChangeWarning(rowData);
        }

        SalesOrderV3Service.setSaleItemPrice(
          newData,
          rowData,
          this.model.SalesOrderTypeCode,
          this.model.BranchCode,
          this.model.CustomerCode,
          this.model.ExchangeRate,
          this.model.DateIn,
          this.model.RequiredByDate,
          false
        ).then((res) => {
          if (res.status == 400 || res.SalesUMQty == undefined) {
            rowData.TiggerPriceLookUp = true;
            res = rowData;

            if (res.ReTryEvents == undefined) res.ReTryEvents = 1;
            else res.ReTryEvents += 1;
          } else {
            res = { ...rowData, ...res };
            res.ReTryEvents = undefined;
            res.TiggerPriceLookUp = false;
          }

          if (
            this.focusedCellData &&
            this.focusedCellData.cellInfo.column.dataField == "SalesUMFXPrice"
          )
            this.$store.dispatch(
              "numericInputStore/updateValue",
              res.SalesUMFXPrice
            );

          res.SalesUMFXPricePreviousValue = res.SalesUMFXPrice;
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid.saveEditData();
          dataGrid.option("loadPanel.enabled", false);

          if (res.IsCopyLine) {
            var index = this.localCopyItems.findIndex((x) => x.ID == res.ID);
            if (index != -1) {
              this.localCopyItems.splice(index, 1);
              this.$nextTick(() => {
                this.localCopyItems.push(res);
                dataGrid.refresh(true);
                this.addToReview(res);
              });
            }
          } else if (
            this.soDetailsCurrentView == "CustomerList" ||
            rowData.Origin == "Customer"
          ) {
            this.customerDataSourceItems.update(res.ID, res).then((data) => {
              dataGrid.refresh(true);
              this.addToReview(data);
            });
          } else if (
            this.soDetailsCurrentView == "ProductList" ||
            rowData.Origin == "Product"
          ) {
            this.productDataSourceItems.update(res.ID, res).then((data) => {
              dataGrid.refresh(true);
              this.addToReview(data);
            });
          } else {
            this.reviewDataList.update(res.ID, res).then((data) => {
              dataGrid.refresh(true);
              this.addToReview(data);
            });
          }

          setTimeout(() => {
            if (
              res.ReTryEvents != undefined &&
              res.ReTryEvents < 4 &&
              res.TiggerPriceLookUp == true
            ) {
              this.updatePriceData(res, res);
            } else if (
              res.ReTryEvents != undefined &&
              res.TiggerPriceLookUp == true
            ) {
              this.$alert(
                `Price request has been failed for ${res.Description} : ${res.ItemCode}. Please check the network connection and try again.`,
                "Warning"
              );
            } else {
              this.$nextTick(() => {
                this.applyFocusClass();
              });
            }
          }, 500);
        });
      }, 100);
    },

    // Header Form
    async setExchangeRateProperties() {
      if (this.model.CompanyCurrency != this.model.CurrencyCode) {
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;
      } else {
        this.model.ExchangeRate = 1;
      }
    },

    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;

      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
            "and",
            ["LineNo", "=", defaultLineNo],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      if (results.length > 0) {
        let deliveryAddressLine1Record = results[0];

        if (deliveryAddressLine1Record) {
          this.model.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.model.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.model.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.model.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.model.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.model.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      } else {
        this.model.DeliveryAddressCompanyName = undefined;
        this.model.DeliveryAddressCountry = undefined;
        this.model.DeliveryAddressPostcode = undefined;
        this.model.DeliveryAddressState = undefined;
        this.model.DeliveryAddressStreetLine1 = undefined;
        this.model.DeliveryAddressStreetLine2 = undefined;
        this.model.DeliveryAddressSuburb = undefined;
        this.model.CustomerDeliveryAddressLineNo = undefined;
      }
    },
    async onDateInValueChanged(e) {
      if (!e.event) return;
      if (e.event && getFactorByCode(616).Factorc == "Date In") {
        if (
          this.allowPriceChangeTriggerConfirmation &&
          this.reviewDataList._array.length > 0
        ) {
          let confirmPriceChange = await this.$confirm(
            `Would you like to recalculate the sell price of all items based upon this new Date In?`,
            "Price Change"
          );

          if (confirmPriceChange) {
            this.triggerPriceChange();
          }
        }
      }
    },
    async onRequiredByDateValueChanged(e) {
      if (!e.event) return;
      let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

      if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
        this.model.ShipDate = e.value;
      }
      if (getFactorByCode(616).Factorc != "Date In") {
        if (
          this.allowPriceChangeTriggerConfirmation &&
          this.reviewDataList._array.length > 0
        ) {
          let confirmPriceChange = await this.$confirm(
            `Would you like to recalculate the sell price of all items based upon this new Reqd Date?`,
            "Price Change"
          );

          if (confirmPriceChange) {
            this.triggerPriceChange();
          }
        }
      }
    },

    // Details Tab
    async onDiscountPrctUpdate(newData, value, currentRowData) {
      if (this.discountTimeOut) clearTimeout(this.discountTimeOut);

      this.discountTimeOut = setTimeout(async () => {
        // newData.DiscPcnt = value;
        var SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
          currentRowData.SalesUMFXPrice,
          value
        );

        let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
          SalesUMNetFXPrice,
          this.model.ExchangeRate
        );

        let tempGp = calculateGrossProfitPcnt(
          currentRowData.SalesUMStandardCost,
          newsalesUMNetPrice
        );

        let globalGPVal = parseFloat(getFactorByCode(571).Factorc);

        if (globalGPVal != 0 && (tempGp < globalGPVal || tempGp > 100)) {
          if (currentRowData.SalesUMQty != 0) {
            let res = await alert(
              `Net Price is below the minimum GP of ${
                globalGPVal.roundNumber(2) + " %"
              }. Please enter a discount that meets the minimum GP % requirement.`,
              "Validation Error"
            );

            if (res) {
              this.$store.dispatch(
                "numericInputStore/updateValue",
                currentRowData.DiscPcnt
              );

              this.$store.dispatch("numericInputStore/lastEntry", {
                value: 0,
                remove: true,
              });

              // newData.DiscPcnt = currentRowData.DiscPcnt;
              var dataGrid = this.$refs["dx-data-grid-comp"].instance;

              this.$nextTick(() => {
                dataGrid.saveEditData();
              });

              setTimeout(() => {
                newData.TriggerDiscountUpdate = false;
                newData.DiscPcnt = currentRowData.DiscPcntPreviousValue;
                this.updateDataSource(newData, currentRowData, true);

                setTimeout(() => {
                  var rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
                  var cell = dataGrid.getCellElement(rowIndex, "DiscPcnt");
                  dataGrid.editCell(rowIndex, "DiscPcnt");

                  this.$nextTick(() => {
                    dataGrid.focus(cell);
                  });
                }, 50);

                setTimeout(() => {
                  this.applyFocusClass();
                }, 100);
              }, 100);
            }
          }

          return newData;
        } else {
          newData.TriggerDiscountUpdate = false;
          newData.DiscPcnt = value;
          newData.DiscPcntPreviousValue = value;
          newData.SalesUMNetFXPrice = SalesUMNetFXPrice;

          var obj = { ...currentRowData, ...newData };
          SalesOrderState.setStockPrices(obj);
          SalesOrderState.setLineTotals(obj, this.model);

          if (obj.SalesUMQty > 0) this.addToReview(obj);

          this.updateDataSource(obj, undefined, true);
        }
      }, 100);
    },
    onPriceUpdateValidateGPToolPrcnt(newData, value, currentRowData) {
      if (this.priceUpdateTimeOut) clearTimeout(this.priceUpdateTimeOut);
      this.priceUpdateTimeOut = setTimeout(async () => {
        // -----
        var SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
          value,
          currentRowData.DiscPcnt
        );

        let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
          SalesUMNetFXPrice,
          this.model.ExchangeRate
        );

        let tempGp = calculateGrossProfitPcnt(
          currentRowData.SalesUMStandardCost,
          newsalesUMNetPrice
        );

        let globalGPVal = parseFloat(getFactorByCode(571).Factorc);

        if (globalGPVal != 0 && tempGp < globalGPVal) {
          if (currentRowData.SalesUMQty != 0) {
            this.$store.dispatch("numericInputStore/lastEntry", {
              value: 0,
              remove: true,
            });
            let res = await alert(
              `Net Price is below the minimum GP of ${
                globalGPVal.roundNumber(2) + " %"
              }. Please enter a discount that meets the minimum GP % requirement.`,
              "Validation Error"
            );

            if (res) {
              var dataGrid = this.$refs["dx-data-grid-comp"].instance;
              this.$nextTick(() => {
                dataGrid.saveEditData();
              });

              setTimeout(() => {
                if (
                  this.focusedCellData &&
                  this.focusedCellData.cellInfo.column.dataField ==
                    "SalesUMFXPrice"
                )
                  this.$store.dispatch(
                    "numericInputStore/updateValue",
                    currentRowData.SalesUMFXPricePreviousValue
                  );

                newData.TriggerPriceUpdate = false;
                newData.SalesUMFXPrice =
                  currentRowData.SalesUMFXPricePreviousValue;
                this.updateDataSource(newData, currentRowData, true);

                setTimeout(() => {
                  var rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
                  var cell = dataGrid.getCellElement(
                    rowIndex,
                    "SalesUMFXPrice"
                  );
                  dataGrid.editCell(rowIndex, "SalesUMFXPrice");

                  this.$nextTick(() => {
                    dataGrid.focus(cell);
                  });
                }, 50);

                setTimeout(() => {
                  this.applyFocusClass();
                }, 100);
              }, 100);
            }
          }
        } else {
          newData.SalesUMFXPrice = value;
          newData.SalesUMFXPricePreviousValue = value;

          newData.SalesUMNetFXPrice = SalesUMNetFXPrice;

          // setBaseCurrencyPriceFromFXPrice
          newData.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
            newData.SalesUMFXPrice,
            this.model.ExchangeRate
          );

          newData.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
            currentRowData.SalesUMStandardPrice,
            newData.SalesUMPrice
          );

          newData.SalesUMNetPrice = newsalesUMNetPrice;

          // setStockPrices
          newData.StockUMQty = calculateStockUMQty(
            currentRowData.SalesUMQty,
            currentRowData.SalesUMConversion
          );

          // Stock
          newData.StockUMFXPrice = calculateStockUMFXPrice(
            newData.SalesUMFXPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMNetFXPrice = calculateStockUMNetFXPrice(
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMPrice = calculateStockUMPrice(
            newData.SalesUMPrice,
            currentRowData.SalesUMConversion
          );

          newData.StockUMNetPrice = calculateStockUMNetPrice(
            newData.SalesUMNetPrice,
            currentRowData.SalesUMConversion
          );

          // setLineTotals
          // FX Totals
          newData.DiscFXLineTotal = calculateDiscFXLineTotal(
            newData.SalesUMFXPrice,
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMQty
          );
          newData.NetFXLineTotal = calculateNetFXLineTotal(
            newData.SalesUMNetFXPrice,
            currentRowData.SalesUMQty
          );
          newData.WetFXLineTotal = calculateWetFXLineTotal(
            newData.NetFXLineTotal,
            currentRowData.WetPcnt
          );

          newData.TaxableFXLineTotal = calculateTaxableFXLineTotal(
            newData.NetFXLineTotal,
            newData.WetFXLineTotal
          );
          newData.TaxFXLineTotal = calculateTaxFXLineTotal(
            newData.NetFXLineTotal,
            newData.WetFXLineTotal,
            currentRowData.SalesTaxPcnt
          );
          newData.FXLineTotal = calculateFXLineTotal(
            newData.TaxableFXLineTotal,
            newData.TaxFXLineTotal
          );

          // Totals
          newData.DiscLineTotal = calculateDiscLineTotal(
            newData.DiscFXLineTotal,
            this.model.ExchangeRate
          );
          newData.NetLineTotal = calculateNetLineTotal(
            newData.NetFXLineTotal,
            this.model.ExchangeRate
          );
          newData.WetLineTotal = calculateWetLineTotal(
            newData.WetFXLineTotal,
            this.model.ExchangeRate
          );
          newData.TaxableLineTotal = calculateTaxableLineTotal(
            newData.TaxableFXLineTotal,
            this.model.ExchangeRate
          );
          newData.TaxLineTotal = calculateTaxLineTotal(
            newData.TaxFXLineTotal,
            this.model.ExchangeRate
          );
          newData.LineTotal = calculateLineTotal(
            newData.FXLineTotal,
            this.model.ExchangeRate
          );

          newData.TriggerPriceUpdate = false;

          newData = { ...currentRowData, ...newData };

          this.addToReview(newData);
          this.updateDataSource(newData);

          this.$nextTick(() => {
            setTimeout(() => {
              var dataGrid = this.$refs["dx-data-grid-comp"].instance;
              dataGrid.saveEditData();

              this.applyFocusClass();
            }, 10);
          });
        }
      }, 200);

      return newData;
    },
    toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
        // "columnChooserButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: this.isTablet ? 130 : 200,
            items: [
              {
                value: "Review",
                text: "Review",
              },
              {
                value: "ProductList",
                text: "Product",
              },
              {
                value: "CustomerList",
                text: "Customer",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.soDetailsCurrentView,
            disabled: this.baseView.mode == "review",
            onValueChanged: (e) => {
              this.forceRefresh = true;
              this.focusedCellData = undefined;
              this.filterFormItems.forEach((element) => {
                if (element.filterDefaultValue)
                  delete element.filterDefaultValue;
              });
              this.showRightContainer = false;
              this.soDetailsCurrentView = e.value;

              if (
                CommonStorage.getItems(
                  this.getFilterPersistenceKey + "-scroll-offset"
                )
              )
                this.scrollingOffSet = JSON.parse(
                  CommonStorage.getItems(
                    this.getFilterPersistenceKey + "-scroll-offset"
                  )
                );

              // if (e.value == "Review") {
              //   var dataGrid = this.$refs["dx-data-grid-comp"].instance;
              //   setTimeout(() => {
              //     console.log("+++++");
              //     this.reviewDataList.load();
              //     dataGrid.option("dataSource", this.reviewDataList);
              //     dataGrid.refresh();
              //   }, 2500);
              // }
            },
          },
        },
        {
          location: "after",
          widget: "dxForm",
          cssClass: "toolbar-right-form",
          visible: this.soDetailsCurrentView != "Review",
          options: {
            formData: this.StockModel,
            items: [
              {
                label: {
                  text: "Available Stock",
                },
                editorType: "dxSwitch",
                dataField: "AvailableStock",
                cssClass: "available-stock-switch",
                editorOptions: {
                  onValueChanged: (e) => {
                    this.applyStockFilter(e);
                  },
                },
              },
            ],
            validationGroup: "DataGridToolBarForm",
            labelLocation: "left",
            showRequiredMark: false,
            colCount: 1,
          },
        },
        searchPanel,
        // columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              item.classList.add("dx-state-invisible");

              setTimeout(() => {
                this.reSizeGrid();
              }, 100);
            },
          },
        }
      );
    },
    onCellPrepared(e) {
      if (e.rowType == "data") {
        if (e.column.dataField == "Available") {
          if (e.value <= 0) {
            e.cellElement.className = "avail-error";
          } else if (e.value > 0) {
            e.cellElement.className = "avail-no-error";
          }

          if (!this.model.BranchCode) {
            e.cellElement.className = "avail-no-error";
          }
        }

        if (
          ["SalesUM", "SalesUMQty", "DiscPcnt", "SalesUMFXPrice"].includes(
            e.column.dataField
          )
        ) {
          if (e.row.data.PSlipStatus == "C") {
            e.cellElement.className = "";
          }
        }
      }
    },
    async getItemPriceDetails(newData, currentRowData) {
      SalesOrderV3Service.setSaleItemPrice(
        newData,
        currentRowData,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false
      ).then((res) => {
        return res;
      });
    },
    addToReview(item) {
      if (this.soDetailsCurrentView != "Review") {
        var i = this.reviewDataList._array.findIndex((x) => x.ID == item.ID);

        if (i == -1) {
          this.reviewDataList.insert(item);
        } else {
          if (item.SalesUMQty == 0) {
            this.reviewDataList.push([
              {
                type: "remove",
                key: item.ID,
              },
            ]);

            this.focusedCellData = undefined;
            this.selectedRowData = undefined;
          } else {
            this.reviewDataList.push([
              {
                type: "update",
                data: item,
                key: item.ID,
              },
            ]);
          }
          this.reviewDataList.load();
        }
      } else {
        if (item.SalesUMQty == 0) {
          this.reviewDataList.push([
            {
              type: "remove",
              key: item.ID,
            },
          ]);

          this.focusedCellData = undefined;
          this.selectedRowData = undefined;
        } else {
          this.reviewDataList.push([
            {
              type: "update",
              data: item,
              key: item.ID,
            },
          ]);
        }
        this.reviewDataList.load();
      }

      setTimeout(() => {
        this.setFooterItems(this.reviewDataList._array);
      }, 200);
    },
    onContentReady(e) {
      this.addGridNoResults(e, this.noDataMessage());

      if (e.component.getDataSource()) {
        this.gridDataSourceItems = e.component.getDataSource()._items;

        if (this.gridDataSourceItems.length > 0 && this.scrollingOffSet) {
          var scrollComponent = e.component.getScrollable();
          scrollComponent.scrollBy(this.scrollingOffSet);
          CommonStorage.saveItems(
            this.getFilterPersistenceKey + "-scroll-offset",
            JSON.stringify(this.scrollingOffSet)
          );
          this.scrollingOffSet = undefined;
        }

        if (this.forceRefresh) {
          this.forceRefresh = false;
          if (this.soDetailsCurrentView != "Review") {
            if (this.StockModel.AvailableStock) {
              this.applyStockFilter({ value: true });
            }
          }
        }
      }
    },
    onOptionChanged(e) {
      var scrollComponent = e.component.getScrollable();

      if (scrollComponent) {
        CommonStorage.saveItems(
          this.getFilterPersistenceKey + "-scroll-offset",
          JSON.stringify(scrollComponent.scrollOffset())
        );
      }
    },

    noDataMessage() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.soDetailsCurrentView == "Review") {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add an Order Line",
        };
      } else if (this.soDetailsCurrentView == "ProductList") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Product Lines",
          message:
            "Products must be marked Available for Sale to appear here.  Head over to the Product screen to adjust this setting.",
        };
      } else if (this.soDetailsCurrentView == "CustomerList") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Order Lines",
          message:
            "Products despatched and invoiced to the customer will show here.  Head over to the Despatch Order screen to despatch and invoice orders for this customer",
        };
      } else {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add an Order Line",
        };
      }

      return noDataMessageObject;
    },
    refreshDataGrid() {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.repaint(true);
    },

    reSizeGrid() {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      dataGrid.beginUpdate();
      dataGrid.updateDimensions();
      dataGrid.endUpdate();
    },
    async onSalesUMQtyFocusIn(e, cellInfo) {
      let inputEl = e.element.querySelector(".dx-texteditor-input");

      this.focusedCellData = {
        e: e,
        cellInfo: cellInfo,
        requestSent: false,
        inputEl: inputEl,
      };

      // e.component.blur();
      this.showNumericKeyPad();

      setTimeout(() => {
        this.applyFocusClass(inputEl);
      }, 1);

      this.$store.dispatch("numericInputStore/setFieldFocused", false);
      this.$store.dispatch("numericInputStore/keyPadFocusChanged");
      this.$store.dispatch("numericInputStore/updateRecord", {
        itemCode: cellInfo.data.ItemCode,
        value: e.component._parsedValue,
      });
    },
    onEditingStart(e) {
      if (e.data.PSlipStatus == "C") e.cancel = true;
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onFocusIn) {
        let func = e.editorOptions.onFocusIn;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    applyFocusClass(inputEl) {
      if (!this.focusedCellData) return;

      if (!inputEl) inputEl = this.focusedCellData.inputEl;

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      var cell = dataGrid.getCellElement(
        this.focusedCellData.cellInfo.rowIndex,
        this.focusedCellData.cellInfo.column.dataField
      );
      // var editor = cell.querySelector("div.gc-grid-number-box-editor");
      // if (editor) editor.classList.add("key-pad-focused");

      if (cell) {
        cell.classList.add("key-pad-focused-cell");
        // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        // dataGrid.refresh(true);
      }
    },
    removeCellFocus() {
      // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      // var cell = dataGrid.getCellElement(
      //   this.focusedCellData.cellInfo.rowIndex,
      //   this.focusedCellData.cellInfo.column.dataField
      // );

      // // var editor = cell.querySelector("div.gc-grid-number-box-editor");
      // // if (editor) editor.classList.remove("key-pad-focused");

      // if (cell) cell.classList.remove("key-pad-focused-cell");

      var cell = document.querySelectorAll(".key-pad-focused-cell");
      if (cell.length > 0) cell[0].classList.remove("key-pad-focused-cell");
    },
    showNumericKeyPad() {
      if (!this.showRightContainer) {
        this.showRightContainer = !this.showRightContainer;
      }
      if (this.sidebarTabSelectedIndex != 1) this.sidebarTabSelectedIndex = 1;

      var item = document.getElementById("filter-btn");
      item.classList.add("dx-state-invisible");

      setTimeout(() => {
        this.reSizeGrid();
      }, 50);
    },
    onSoDetailsLineContextMenuItemClick(e) {
      if (e.itemData.menuText == "Line Comment") {
        let rowData = e.itemData.data.data;

        let visibleOnInvoiceFactor = getFactorByCode(505);

        this.lineCommentItems.RowData = rowData;
        this.lineCommentModel.ID = rowData.ID;
        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentModel.IsCommentVisible =
          rowData.LineNo == 0
            ? visibleOnInvoiceFactor.Factorc == "Y"
              ? true
              : rowData.IsCommentVisible
            : rowData.IsCommentVisible;

        this.lineCommentsPopupVisible = true;
      } else if (e.itemData.menuText == "Item History") {
        this.model.LineItemCode = e.itemData.data.data.OriginItemCode;
        this.customerItemHistory = e.itemData.data.data;
        this.itemHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Order Item History");
      } else if (e.itemData.menuText == "GP Tool") {
        if (e.itemData.data.data.SalesUMQty == 0) {
          this.displayValidationErrors([
            `Quantity cannot be 0. Please enter a quantity to access the GP Tool.`,
          ]);
        } else {
          this.gpToolPopupVisible = true;
          this.$logger.trackEventOpenPopup("Sales Order GP Tool");
          this.go;
          this.gpTool.data = e.itemData.data.data;
          this.gpTool.cellInfo = e.itemData.data;
          this.gpTool.model.quantity = e.itemData.data.data.SalesUMQty;
          this.gpTool.model.standardSell =
            e.itemData.data.data.SalesUMStandardPrice * this.model.ExchangeRate;
          this.gpTool.model.currentPrice =
            e.itemData.data.data.SalesUMNetFXPrice;

          this.gpTool.model.gp =
            this.gpTool.data.gpprcnt > 0
              ? this.gpTool.data.gpprcnt
              : calculateGrossProfitPcnt(
                  Math.round(e.itemData.data.data.SalesUMStandardCost * 100) /
                    100,
                  e.itemData.data.data.SalesUMNetFXPrice
                );
          this.gpTool.model.newSalesUMNetPrice =
            e.itemData.data.data.SalesUMNetFXPrice;
        }
      } else if (e.itemData.menuText == "Copy Line") {
        if (this.focusedCellData) this.removeCellFocus();
        this.focusedCellData = undefined;
        this.selectedRowData = undefined;
        var copyItem = { ...e.itemData.data.data };
        if (copyItem.IsCopyLine) {
          copyItem.ItemCode =
            copyItem.OriginItemCode + "-" + new Date().getTime();
        } else {
          copyItem.ItemCode = copyItem.ItemCode + "-" + new Date().getTime();
        }
        copyItem.ID = copyItem.ItemCode;

        if (copyItem.SalesOrderCode != 0) copyItem.SalesOrderCode = 0;

        copyItem.SalesUMQty = 0;
        copyItem.CustomerSalesContractCode = null;
        copyItem.CustomerSalesContractLineNo = null;
        copyItem.IsCopyLine = true;
        copyItem.LineNo = 0;
        copyItem.SalesUMSuppliedQty = 0;

        copyItem = SalesOrderState.setStockPrices(copyItem);
        copyItem = SalesOrderState.setLineTotals(copyItem, this.model);

        // this.localCopyItems.push(copyItem);

        if (this.soDetailsCurrentView == "Review") {
          this.reviewDataList.insert(copyItem);
        }

        if (this.soDetailsCurrentView == "CustomerList") {
          this.customerDataSourceItems.insert(copyItem);
          // this.customerDataSourceItems.push([
          //   {
          //     type: "insert",
          //     data: copyItem,
          //     index: e.itemData.data.rowIndex + 1,
          //   },
          // ]);
          this.productDataSourceItems.push([
            { type: "insert", data: copyItem },
          ]);
        }

        if (this.soDetailsCurrentView == "ProductList") {
          // this.productDataSourceItems.push([
          //   {
          //     type: "insert",
          //     data: copyItem,
          //     index: e.itemData.data.rowIndex + 1,
          //   },
          // ]);
          this.productDataSourceItems.insert(copyItem);
        }

        // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        // var ds = dataGrid.getDataSource();
        // ds.requireTotalCount(false);
        // ds.reload();

        setTimeout(() => {
          this.$nextTick(() => {
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;
            dataGrid.saveEditData();
            // dataGrid.repaint();
            dataGrid.refresh();

            var ds = dataGrid.getDataSource();
            ds.reload();
          });
        }, 1);

        // this.customerDataSourceItems.load();
      }
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },
    popupLineCommentBackButtonClick() {
      this.lineCommentsPopupVisible = false;

      var rowData = this.lineCommentItems.RowData;
      rowData.Comment = this.lineCommentModel.Comment;
      rowData.IsCommentVisible = this.lineCommentModel.IsCommentVisible;

      this.addToReview(rowData);
    },
    itemHistoryPopupHidden() {
      this.model.LineItemCode = undefined;
      this.$refs["itemHistoryGrid"].instance.clearFilter("search");

      this.itemHistoryPopupVisible = false;
    },
    itemHistoryPopupShown(e) {
      this.itemHistoryDataGridHeight = e.component.content().clientHeight - 60;
    },
    itemDetailsPopupHidden() {
      this.productDetails.imageURL = null;
      this.productDetailsPopupVisible = false;
    },
    itemHistoryToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "displayDescription",
      });
    },
    itemHistoryAddGridNoResults(e) {
      let noDataMessageObject = {
        addNew: {
          class: undefined,
          title: "No History Lines",
          message:
            "Products despatched and invoiced to the customer will show here. Head over to the Despatch Order screen to despatch and invoice orders for this customer.",
        },
      };
      this.addGridNoResults(e, noDataMessageObject);
    },
    async setItemPromotions(items) {
      if (
        this.model.BranchCode != undefined &&
        this.model.FilterDate != undefined
      ) {
        let itemCodeChunks = chunkArray(items, 20);
        var filterValues = "";

        let promoPromiseArr = [];
        for (let i = 0; i < itemCodeChunks.length; i++) {
          filterValues = getFilterExpressionForArray(
            "ItemCode",
            "OriginItemCode",
            itemCodeChunks[i]
          );

          var promoFilter =
            "(" +
            filterValues +
            ") and CustomerCode eq '" +
            this.model.CustomerCode +
            "' and (StartDate le " +
            this.model.FilterDate +
            "T00:00:00Z" +
            " and EndDate ge " +
            this.model.FilterDate +
            "T00:00:00Z" +
            ")";

          promoPromiseArr.push(
            SalesOrderService.getSalesOrderPromotion(promoFilter)
          );
        }

        Promise.all(promoPromiseArr).then((results) => {
          var promoItems = [];
          results.forEach((result) => {
            var getData = result.data.value;
            for (let index = 0; index < getData.length; index++) {
              var getIndex = items.findIndex(
                (x) =>
                  x.OriginItemCode == getData[index].ItemCode &&
                  getData[index].PriceGroupType != "S"
              );
              if (getIndex > -1) {
                promoItems.push(items[getIndex]);
              }
            }
          });

          this.updatePromoItems(items, promoItems);
        });
      }
    },
    updatePromoItems(items, promoItems) {
      promoItems.forEach((element) => {
        var index = this.productDataSourceItems._array.findIndex(
          (x) => x.OriginItemCode == element.ItemCode
        );
        if (index != -1) {
          // this.productDataSourceItems._array[index]["HasPromotion"] = true;
          this.productDataSourceItems.update(
            this.productDataSourceItems._array[index].ID,
            { HasPromotion: true }
          );
        }

        var cIndex = this.customerDataSourceItems._array.findIndex(
          (x) => x.OriginItemCode == element.ItemCode
        );
        if (cIndex != -1)
          this.customerDataSourceItems._array[cIndex]["HasPromotion"] = true;
      });
      // }

      if (this.baseView.mode != "create") {
        items.forEach((element, elIndex) => {
          var index = promoItems.findIndex(
            (i) => i.OriginItemCode == element.OriginItemCode
          );
          if (index != -1) {
            this.reviewDataList.push([
              {
                type: "update",
                data: {
                  HasPromotion: true,
                },
                key: items[elIndex].ID,
              },
            ]);
          }
        });
      }

      // var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      // dataGrid.refresh();
    },
    async triggerPriceChange() {
      this.setSaleItemPriceAllLines();
    },
    setSaleItemPriceAllLines() {
      if (this.reviewDataList._array.length > 0) {
        var promises = [];
        for (var i = 0; i < this.reviewDataList._array.length; i++) {
          var record = this.reviewDataList._array[i];
          if (record.ItemCode)
            promises.push(
              SalesOrderV3Service.setSaleItemPrice(
                // REPRICE ALL
                record,
                record,
                this.model.SalesOrderTypeCode,
                this.model.BranchCode,
                this.model.CustomerCode,
                this.model.ExchangeRate,
                this.model.DateIn,
                new Date(this.model.RequiredByDate),
                false
              )
            );
        }

        Promise.all(promises).then((data) => {
          data.forEach((element) => {
            this.addToReview(element);
          });
        });
      }
    },
    onSalesUMRowClick(e) {
      this.popupHiddenCallBack(false);
      var rowIndex = this.selectedRowData.rowIndex;
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.cellValue(rowIndex, "SalesUM", e.data.SalesUM);

      this.selectedRowData = undefined;
    },
    updateReviewList(data) {
      this.reviewDataList.push([
        {
          type: "update",
          data: data,
          key: data.ID,
        },
      ]);
    },
    applyStockFilter(e) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      var filters = [];

      if (e.value) {
        filters.push([["Available", ">", 0]]);
        dataGrid.filter(filters);
      } else {
        filters.push([["Available", "<>", 0], "or", ["Available", "=", 0]]);
        dataGrid.filter(filters);
      }
    },

    // GP Tool
    async applyGPToolValue() {
      var globalGPVal = parseFloat(getFactorByCode(571).Factorc);
      if (
        globalGPVal != 0 &&
        (this.gpTool.model.gp < 0 || this.gpTool.model.gp > 100)
      ) {
        this.displayValidationErrors([
          `GP % value should be between 99.99 and 0.00`,
        ]);
      } else if (this.gpTool.model.gp < globalGPVal) {
        this.displayValidationErrors([
          `Cannot save New Price below the min GP % (` +
            globalGPVal.toFixed(2) +
            `)`,
        ]);
      } else {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        var rowIndex = this.gpTool.cellInfo.rowIndex;

        var SalesUMFXPrice = calculateSalesUMFXPriceFromSalesUMNetFXPrice(
          this.gpTool.model.newSalesUMNetPrice,
          this.gpTool.data.DiscPcnt
        );

        dataGrid.cellValue(rowIndex, "SalesUMFXPrice", SalesUMFXPrice);
        dataGrid.cellValue(rowIndex, "gpprcnt", this.gpTool.model.gp);

        this.gpToolPopupVisible = false;
      }
    },
    gpPercentageChange() {
      this.gpTool.model.newSalesUMNetPrice = calculateSalesUMPriceForGP(
        Math.round(this.gpTool.model.standardSell * 100) / 100,
        Math.round(this.gpTool.data.SalesUMStandardCost * 100) / 100,
        this.gpTool.model.gp
      );
    },
    async onGpValueChanged(e) {
      if (!e.event) return;

      if (e.value >= 100 || e.value < 0) {
        let res = await alert(
          "GP % must have a value between 0 and 100",
          "Invalid GP Value"
        );
        if (res) {
          this.gpTool.model.gp = e.previousValue;
          this.gpPercentageChange();
        }
      }
    },
    gpNewPriceChange() {
      this.gpTool.model.gp =
        this.gpTool.model.newSalesUMNetPrice == 0
          ? 0
          : (
              ((this.gpTool.model.newSalesUMNetPrice -
                Math.round(this.gpTool.data.SalesUMStandardCost * 100) / 100) /
                this.gpTool.model.newSalesUMNetPrice) *
              100
            ).roundNumber(2);
    },

    // Item Details
    async clickOnInfo(data) {
      this.showLoading(true);

      this.productDetails.data = { ...data.data };
      if (
        this.productDetails.data.SalesUMQty == 0 &&
        this.productDetails.data.HasPromotion
      ) {
        var newData = { SalesUMQty: 1 };
        var obj = { ...this.productDetails.data, ...newData };
        await SalesOrderV3Service.setSaleItemPrice(
          obj,
          obj,
          this.model.SalesOrderTypeCode,
          this.model.BranchCode,
          this.model.CustomerCode,
          this.model.ExchangeRate,
          this.model.DateIn,
          this.model.RequiredByDate,
          false
        ).then((res) => {
          this.productDetails.data = res;
        });
      }
      this.productDetails.model.itemCode = data.data.OriginItemCode;
      this.productDetails.model.salesUM = data.data.SalesUM;

      await this.getProductUnitOfMeasure(this.productDetails.data);

      if (this.productDetails.data.HasPrimaryImage) {
        let itemCode = data.data.OriginItemCode;
        await ApiService.get("/api/ProductPrimaryImage?itemCode=" + itemCode)
          .then((res) => {
            var src = "data:image;base64," + res.data.value;
            this.productDetails.imageURL = src;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });
      }

      this.showLoading(false);
      this.productDetailsPopupVisible = true;
    },
    async getProductUnitOfMeasure(data) {
      var that = this;
      that.productDetails.hasPromotion = false;
      that.productDetails.model.promotionStartDate = null;
      that.productDetails.model.promotionEndDate = null;

      await SalesOrderProductDetails.getProductUnitOfMeasureByCode(
        data.OriginItemCode,
        this.model.BranchCode,
        data.SalesUM
      )
        .then(async (result) => {
          if (
            data.HasPromotion &&
            data.PriceGroupCode != 0 &&
            data.PriceGroupCode != null
          ) {
            await PriceGroupService.getByCode(data.PriceGroupCode)
              .then((result1) => {
                that.productDetails.hasPromotion =
                  result1.data.value[0].DateControlled;
                that.productDetails.model.promotionStartDate =
                  result1.data.value[0].SellStartDate;
                that.productDetails.model.promotionEndDate =
                  result1.data.value[0].SellEndDate;
              })
              .catch((err) => {
                if (err) this.showLoading(false);
              });
          }

          this.productDetails.model.apn = result.data.value[0].Product.APN;
          this.productDetails.model.cartonQty =
            result.data.value[0].Product.PackSize;
          this.productDetails.model.standardSell =
            result.data.value[0].StandardSell;
          if (data.SalesUMQty == 0) {
            this.productDetails.model.customerSell =
              result.data.value[0].StandardSell;
          } else {
            this.productDetails.model.customerSell =
              this.productDetails.data.SalesUMPrice;
          }

          this.showLoading(false);
        })
        .catch((err) => {
          if (err) this.showLoading(false);
        });
    },

    // Available Stock

    stockLevelCallBack() {
      this.visibleStockLevels = !this.visibleStockLevels;
    },
    visibleStockLevel(item) {
      this.stockLevelItemData = {
        ItemCode: item.OriginItemCode,
        Description: item.Description,
      };
      this.visibleStockLevels = !this.visibleStockLevels;
    },

    // Filter side panel
    changeFilterPanelTab(e) {
      this.sidebarTabSelectedIndex = e.itemIndex;
    },
    setGridPanelFilter(filters, valueChanged) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      if (valueChanged != undefined || filters.length > 0) {
        this.forceRefresh = true;
        CommonStorage.saveItems(
          "filter-panel-" + this.getFilterPersistenceKey,
          JSON.stringify(filters) // , replacer
        );
        var finalFilter = [];
        if (this.getDefaultFilters) {
          if (filters.length > 0) {
            if (filters[filters.length - 1] != "and") filters.push("and");
            finalFilter = filters.concat(this.getDefaultFilters);
          } else finalFilter = this.getDefaultFilters;
        } else finalFilter = filters;

        if (finalFilter.length > 0) dataGrid.filter(finalFilter);
        else if (finalFilter.length == 0) dataGrid.clearFilter();

        if (filters.length == 0) {
          this.filterFormItems.forEach((element) => {
            if (element.filterDefaultValue) delete element.filterDefaultValue;
          });
          this.filterRefreshKey++;
        }
      }
      this.showLoading(false);
    },
    closeFilterPanel() {
      this.showRightContainer = !this.showRightContainer;
      this.sidebarTabSelectedIndex = 0;
      var item = document.getElementById("filter-btn");
      item.classList.remove("dx-state-invisible");

      setTimeout(() => {
        this.reSizeGrid();
      }, 50);
    },

    // Footer
    async setFooterItems(gridItems) {
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
  },
  watch: {
    // numericValue: function (val) {
    // },
    numericValue: {
      handler(val) {
        if (val === undefined) return;
        if (this.focusedCellData && this.fieldFocused) {
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid.cellValue(
            this.focusedCellData.cellInfo.rowIndex,
            this.focusedCellData.cellInfo.column.dataField,
            val
          );
          setTimeout(() => {
            this.applyFocusClass();
          }, 50);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.touch-sales-order-layout {
  .dx-scrollable-content {
    min-height: 100% !important;
  }
  .layout-body .dx-scrollable-wrapper .dx-scrollable-content {
    .dx-scrollview-content .content {
      //   padding: 10px;
      .touch-sales-order {
        background-color: white;
        // padding: 10px;
      }
    }

    .header-form-container {
      width: 100%;
      display: inline-flex;

      .header-form {
        width: calc((100% / 3) * 2);
        padding-right: 5px;
        margin-bottom: 0 !important;
      }

      .header-comments {
        width: calc((100% / 3) * 1);
        padding-left: 5px;
      }
    }

    .dx-datagrid .dx-row.dx-data-row.dx-row-lines .key-pad-focused-cell {
      background-color: #d1f7ffba !important;
    }

    // .dx-cell-modified {
    //   // background-color: unset !important;
    // }

    .advance-filter-panel {
      .dx-form .dx-scrollable-container {
        margin-left: 0;
        padding-left: 0;
        .dx-scrollable-content {
          .dx-layout-manager.dx-widget {
            padding-right: 0;
          }
        }
      }
    }
    .dx-icon-money::before {
      color: #20a4da;
    }

    .class-item-cell-template {
      cursor: pointer;
    }

    .gc-grid-footer-css-v2.t-so-foolter-h {
      position: absolute;
      bottom: 10px;
      width: calc(100% - 20px);
    }

    .dx-datagrid-rowsview {
      thead {
        display: none;
      }

      .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
        background-color: #f8fdfe !important;
        // #d1f7ffba !important
      }
      // .edit-cell-textbox-field gc-editable-cell-color dx-editor-cell
      // edit-cell-textbox-field gc-editable-cell-color
      // .dx-row:not(.dx-row-alt){
      .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-alt) > td,
      .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-alt):hover > td {
        background-color: unset;
      }
      // }

      // .dx-row.dx-row-alt {
      .dx-selection.dx-row.dx-row-alt:not(.dx-row-focused)
        > td:not(.gc-editable-cell-color),
      .dx-selection.dx-row.dx-row-alt:not(.dx-row-focused):hover
        > td:not(.gc-editable-cell-color),
      .dx-selection.dx-row.dx-row-alt:not(.dx-row-focused) > td.cell-disabled,
      .dx-selection.dx-row.dx-row-alt:not(.dx-row-focused):hover
        > td.cell-disabled {
        background-color: #f5f5f5 !important;
      }
      // }

      .dx-data-row:not(.dx-row-alt).dx-state-hover:not(.dx-selection):not(
          .dx-row-inserted
        ):not(.dx-row-removed):not(.dx-edit-row):not(.dx-row-focused)
        > td:not(.dx-focused) {
        background-color: unset;
      }
    }
    .dx-datagrid
      .dx-datagrid-content
      .dx-datagrid-table
      .dx-row
      .dx-editor-cell {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }

  .css-v2.transaction-screen {
    background-color: unset !important;
  }

  .edit-cell-numberbox-field {
    .dx-numberbox.dx-texteditor:not(.dx-state-readonly)::after {
      content: "";
      border-bottom: unset !important;
      background-color: unset !important;
    }
    .dx-numberbox.dx-texteditor.dx-state-readonly {
      border-bottom-style: unset !important;
      border-bottom-width: unset !important;
    }
  }

  .qty-cell:not([role="columnheader"])[role="gridcell"] {
    border-left: 3px solid white !important;
    border-right: 3px solid white !important;
  }
  .dx-datagrid .dx-row-alt > td.dx-cell-modified {
    background-color: #f5f5f5 !important;
  }
}

.dx-device-tablet {
  .touch-sales-order-layout {
    .layout-body {
      .gc-header-toolbar .gc-form-header-toolbar {
        .view-toolbar.form-header-toolbar {
          .dx-toolbar-items-container {
            .dx-toolbar-before {
              padding-left: 12px;
            }
            .dx-toolbar-after {
              padding-right: 12px;
            }
          }
        }
      }
    }
  }
}

.popup-in-header {
  padding: 10px 10px 0 10px;
  > div {
    background-color: white;
    > div {
      padding: 10px;
    }
  }
}

.gc-popup-product-details {
  .product-details {
    max-width: 100%;
    max-height: 80vh;
    overflow: auto;
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 10px;

    .popup-in-header {
      padding: 0 !important;
      padding-bottom: 10px !important;
    }

    .details-row {
      // padding: 10px;
      background-color: white;
    }

    .row {
      align-items: center !important;
      display: flex;
      flex-wrap: wrap;

      .col-6 {
        flex: 0 0 50%;
        max-width: 50%;
        position: relative;
        width: 100%;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;

        input {
          text-align: right;
        }

        .product-primary-image-img {
          text-align: center;
          overflow: auto;

          .no-image {
            border: 1px solid #ece1e1;
            width: 140px;
            height: 140px;
            text-align: center;
            display: inline-flex;

            span {
              width: auto;
              margin: auto;
              display: block;
              float: none;
              max-width: 100%;
            }
          }
        }
      }
    }
  }
}

.toolbar-right-form {
  .dx-form {
    .dx-first-row {
      padding: 0 !important;
    }

    .available-stock-switch {
      .dx-field-item-content > div {
        margin-top: 0 !important;
      }
    }
  }
}
</style>
